export const translations = {
  sv: {
    // Nav
    "nav.marketplace": "Marknadsplats",
    "nav.addListing": "Ny annons",
    "nav.dashboard": "Översikt",
    "nav.signIn": "Logga in",
    "nav.signOut": "Logga ut",
    "nav.footer": "ReSource Build / Cirkulärt byggande",
    "nav.noRole": "ingen roll",
    "role.seller": "säljare",
    "role.buyer": "köpare",
    "role.admin": "admin",
    "role.switcher": "Byt roll:",

    // Landing
    "landing.hero.label": "[ 001 / Marknadsplats för cirkulärt byggande ]",
    "landing.hero.title1": "Marknadsplatsen",
    "landing.hero.title2": "för material med",
    "landing.hero.title3": "ett andra liv.",
    "landing.hero.subtitle": "Lägg upp överblivet tegel, virke, kakel och stål — eller boka återvunnet material från byggare nära dig. Hämtning eller leverans.",
    "landing.hero.browse": "Bläddra material",
    "landing.hero.pickup": "Finns för hämtning",
    "landing.stats.tons": "Ton återanvänt",
    "landing.stats.sellers": "Aktiva säljare",
    "landing.stats.categories": "Kategorier",
    "landing.intake.label": "Senaste inleverans",
    "landing.intake.text": "Stockholms lager · 2 400 återvunna tegelstenar",
    "landing.cats.label": "[ Kategorier ]",
    "landing.cats.title": "Handla efter material",
    "landing.cats.viewAll": "Visa alla →",
    "landing.cats.category": "Kategori",
    "landing.how.label": "[ Så funkar det ]",
    "landing.how.title": "Byggt för bygget.",
    "landing.how.s1.title": "01 / Lägg upp överskott",
    "landing.how.s1.body": "Byggare och rivningsteam publicerar överblivet material med foton, mängd och kvalitet.",
    "landing.how.s2.title": "02 / Boka & reservera",
    "landing.how.s2.body": "Köpare reserverar exakt den mängd de behöver — per pall, kvadratmeter eller styck.",
    "landing.how.s3.title": "03 / Hämtning eller leverans",
    "landing.how.s3.body": "Välj överlämning. Säljare bekräftar, köpare hämtar eller får det levererat.",
    "landing.cta.label": "[ Börja sälja ]",
    "landing.cta.title": "Har du material över? Förvandla avfall till värde.",
    "landing.cta.browse": "Bläddra först",
    "landing.cta.sell": "Börja sälja",

    // Marketplace
    "market.label": "[ Inventering ]",
    "market.title": "Marknadsplats",
    "market.scopePublic": "Offentliga",
    "market.scopePublicHint": "Alla publicerade material som syns för alla användare",
    "market.scopeShared": "Delade",
    "market.scopeSharedHint": "Material som dina samarbetsorganisationer delar med er",
    "market.scopeOwn": "Internt",
    "market.scopeOwnHint": "Bara material som ni själva har lagt in",
    "market.projectFilter": "Projekt:",
    "market.projectAll": "Alla projekt",
    "market.bulkSelected": "{n} markerade",
    "market.bulkMove": "Flytta till projekt",

    // Move material
    "move.label": "[ Flytta material ]",
    "move.title": "Flytta till annat projekt",
    "move.bulkLabel": "[ Bulk-flytt ]",
    "move.bulkTitle": "Flytta {n} material",
    "move.targetProject": "Målprojekt",
    "move.targetPlaceholder": "Välj projekt…",
    "move.targetDetach": "— Inget projekt (koppla bort) —",
    "move.currentMark": "nuvarande",
    "move.warehouseHint": "Tips: detta ser ut som ett lager-projekt. Bra för demonterat material som ska centrallagras.",
    "move.note": "Anteckning (valfritt)",
    "move.notePh": "T.ex. \"Demontering klar — flyttat till central-lager\"",
    "move.confirm": "Flytta",
    "move.moving": "Flyttar…",
    "move.success": "Material flyttat",
    "move.bulkSuccess": "{moved} av {total} flyttade",
    "move.failed": "Kunde inte flytta",
    "move.pickTarget": "Välj ett målprojekt först",
    "move.sameTarget": "Materialet ligger redan i det projektet",
    "move.openBtn": "Flytta till projekt",
    "move.historyShow": "Visa flytthistorik",
    "move.historyHide": "Dölj flytthistorik",
    "move.historyTitle": "Flytthistorik",
    "move.historyEmpty": "Inga flyttar registrerade ännu",
    "move.noProject": "—",
    "common.cancel": "Avbryt",
    "common.save": "Spara",
    "common.close": "Stäng",
    "market.items": "objekt",
    "market.grid": "Rutnät",
    "market.map": "Karta",
    "market.filters": "Filter",
    "market.search": "Sök",
    "market.searchPh": "Tegel, balkar...",
    "market.category": "Kategori",
    "market.allCategories": "Alla kategorier",
    "market.quality": "Kvalitet",
    "market.any": "Alla",
    "market.locationText": "Plats (text)",
    "market.locationPh": "Ort eller region",
    "market.distance": "Avstånd",
    "market.useMyLocation": "Använd min plats",
    "market.within": "Inom",
    "market.kmFromYou": "km från dig",
    "market.clearLocation": "Rensa plats",
    "market.handover": "Överlämning",
    "market.pickupAvailable": "Hämtning tillgänglig",
    "market.deliveryAvailable": "Leverans tillgänglig",
    "market.reset": "Rensa filter",
    "market.loading": "Laddar inventering...",
    "market.emptyLabel": "[ Tom hylla ]",
    "market.emptyTitle": "Inga material matchar",
    "market.emptyBody": "Försök lätta på filtren — eller bli först med att lägga upp den här sortens material.",
    "market.geoUnsupported": "Geolokalisering stöds inte",
    "market.centered": "Centrerat på din plats",
    "market.geoFailed": "Kunde inte hämta din plats",

    // Listing card / detail
    "card.noImage": "Ingen bild",
    "card.free": "Gratis",
    "card.view": "Visa →",
    "card.fullyBooked": "Helt bokat",
    "card.kmAway": "km bort",
    "detail.back": "← Tillbaka till marknadsplatsen",
    "detail.loading": "Laddar...",
    "detail.notFound": "Annonsen hittades inte",
    "detail.pickup": "Hämtning",
    "detail.delivery": "Leverans",
    "detail.available": "tillgängligt",
    "detail.remaining": "kvar att boka",
    "detail.price": "Pris",
    "detail.freeHandover": "Fri överlämning",
    "detail.description": "Beskrivning",
    "detail.seller": "Säljare",
    "detail.bookBtn": "Boka detta material",
    "detail.loginFirst": "Logga in först för att boka detta material",
    "detail.switchBuyer": "Byt till köparroll i översikten för att boka",
    "detail.cantBookOwn": "Du kan inte boka din egen annons",

    // Booking modal
    "book.label": "[ Boka material ]",
    "book.quantity": "Mängd",
    "book.available": "tillgängligt",
    "book.remaining": "kvar att boka",
    "book.method": "Överlämningssätt",
    "book.address": "Leveransadress",
    "book.addressPh": "Gata, ort, postnummer",
    "book.note": "Meddelande till säljaren",
    "book.notePh": "När kan du hämta? Något särskilt?",
    "book.submit": "Skicka bokningsförfrågan",
    "book.sending": "Skickar...",
    "book.quantityErr": "Mängden måste vara mellan 1 och",
    "book.addressErr": "Ange en leveransadress",
    "book.sent": "Bokningsförfrågan skickad!",
    "book.failed": "Bokningen misslyckades",

    // Add listing
    "add.label": "[ Ny annons ]",
    "add.title": "Lägg upp material",
    "add.loginRequired": "Inloggning krävs.",
    "add.roleRequiredLabel": "[ Roll krävs ]",
    "add.roleRequired": "Du behöver säljarroll för att lägga upp material",
    "add.goDashboard": "Gå till översikt",
    "add.photos": "Bilder",
    "add.dropPhotos": "Släpp bilder eller klicka för att välja",
    "add.uploading": "Laddar upp...",
    "add.photoHint": "JPG / PNG · upp till 10 MB per bild",
    "add.titleField": "Titel",
    "add.titlePh": "t.ex. 500 återvunna röda tegelstenar",
    "add.descField": "Beskrivning",
    "add.descPh": "Mått, ursprung, skick...",
    "add.categoryField": "Kategori",
    "add.qualityField": "Kvalitet",
    "add.quantityField": "Tillgänglig mängd",
    "add.unitField": "Enhet",
    "add.weightLabel": "Vikt per styck — krävs för korrekt CO₂e-beräkning",
    "add.weightHelp": "Den valda kategorin räknas per kilo. Eftersom enheten är \"{unit}\" behöver vi vikten per enhet för att kunna räkna ut klimatvinsten korrekt. Lämna tomt om du inte vet — då visas 0 kg CO₂e.",
    "add.weightPreview": "≈ {qty} {unit} × {weight} kg = {co2e} kg CO₂e (preview)",
    "add.locationField": "Plats",
    "add.locationPh": "Ort, region",
    "add.mapLabel": "Nål på karta (valfritt — aktiverar avståndssökning)",
    "add.priceField": "Pris (kr) · 0 = gratis",
    "add.handover": "Överlämningsalternativ",
    "add.pickup": "Hämtning",
    "add.delivery": "Leverans",
    "add.cancel": "Avbryt",
    "add.publish": "Publicera annons",
    "add.publishing": "Publicerar...",
    "add.editLabel": "[ Redigera annons ]",
    "add.editTitle": "Redigera annons",
    "add.saveChanges": "Spara ändringar",
    "add.saving": "Sparar...",
    "add.updateOk": "Annons uppdaterad",
    "add.updateFail": "Kunde inte uppdatera annonsen",
    "detail.edit": "Redigera",
    "add.uploadOk": "bild(er) uppladdade",
    "add.uploadFail": "Uppladdning misslyckades",
    "add.fillErr": "Fyll i titel, beskrivning och plats",
    "add.publishOk": "Annons publicerad!",
    "add.publishFail": "Kunde inte publicera",

    // Dashboard
    "dash.welcome": "[ Välkommen,",
    "dash.pickRole": "Välj din roll",
    "dash.pickRoleBody": "Du kan ändra detta senare. Säljare lägger upp material. Köpare bläddrar och bokar dem.",
    "dash.iamSeller": "Jag är säljare",
    "dash.iamSellerBody": "Lägg upp överblivet tegel, virke, kakel — förvandla restlager till inkomst.",
    "dash.iamBuyer": "Jag är köpare",
    "dash.iamBuyerBody": "Bläddra återvunnet material och boka precis det du behöver för ditt projekt.",
    "dash.roleSet": "Roll satt till",
    "dash.roleFail": "Kunde inte sätta roll",
    "dash.switched": "Bytt till",
    "dash.label": "[ Översikt /",
    "dash.hello": "Hej,",
    "dash.switchTo": "Byt till",
    "dash.newListing": "Ny annons",
    "dash.myListings": "Mina annonser",
    "dash.incoming": "Inkommande bokningar",
    "dash.myBookings": "Mina bokningar",
    "dash.emptyInventory": "[ Tomt lager ]",
    "dash.noListings": "Inga annonser ännu",
    "dash.postFirst": "Lägg upp din första annons",
    "dash.noIncoming": "Inga inkommande bokningar",
    "dash.noBookings": "Inga bokningar ännu",
    "dash.browse": "Bläddra marknadsplats",
    "dash.from": "från",
    "dash.approve": "Godkänn",
    "dash.reject": "Avvisa",
    "dash.complete": "Markera slutförd",
    "dash.cancel": "Avbryt",
    "dash.confirmDelete": "Ta bort denna annons?",
    "dash.deleted": "Borttagen",
    "dash.failed": "Misslyckades",
    "dash.markedAs": "Markerad som",

    "status.pending": "väntar",
    "status.approved": "godkänd",
    "status.rejected": "avvisad",
    "status.completed": "slutförd",
    "status.cancelled": "avbruten",
    "status.expired": "förfallen",
    "dash.expiresInDays": "Avbryts om {n} d om ej godkänd",
    "dash.expiresInHours": "Avbryts om {n} h om ej godkänd",
    "dash.expiresHint": "Pending-bokningar förfaller automatiskt efter 7 dagar",

    // Map
    "map.pin": "Nål:",
    "map.geocoding": "geokodar...",
    "map.clickToPin": "Klicka på kartan för att sätta nål",
    "map.useLocation": "Använd min plats",
    "map.viewListing": "Visa annons →",
    "map.kmAway": "km bort",

    // Notifications
    "notif.title": "Aviseringar",
    "notif.empty": "Inga aviseringar ännu",
    "notif.markAllRead": "Markera alla som lästa",
    "notif.justNow": "nyss",
    "notif.minAgo": "min sedan",
    "notif.hAgo": "h sedan",
    "notif.dAgo": "d sedan",
    "notif.booking_created": "Ny bokningsförfrågan från {other} för {listing}",
    "notif.booking_approved": "{other} godkände din bokning för {listing}",
    "notif.booking_rejected": "{other} avvisade din bokning för {listing}",
    "notif.booking_completed": "Bokningen för {listing} markerades som slutförd",
    "notif.booking_cancelled": "{other} avbröt bokningen för {listing}",
    "notif.booking_expired": "Din bokning för {listing} har förfallit (ej godkänd inom 7 dagar)",
    "notif.rating_received": "{other} gav dig en recension för {listing}",
    "notif.collab_invite_received": "{other} har bjudit in din organisation till samarbete",
    "notif.collab_invite_accepted": "{other} accepterade ert samarbete",
    "notif.collab_invite_declined": "{other} avböjde er samarbetsinbjudan",
    "notif.user_invite_received": "{other} har bjudit in dig till organisationen",
    "notif.user_invite_accepted": "{other} accepterade din inbjudan",
    "notif.user_invite_declined": "{other} avböjde din inbjudan",
    "notif.toastNew": "Ny avisering",

    // User-to-Org invitations (domain-matched colleagues)
    "uinv.title": "Bjud in användare till organisationen",
    "uinv.help": "Användare som registrerat sig med samma e-postdomän som er organisation visas här. Du kan också ange en e-post manuellt.",
    "uinv.noMatches": "Inga matchande användare just nu.",
    "uinv.inviteBtn": "Bjud in",
    "uinv.manualEmail": "Bjud in via e-post",
    "uinv.send": "Skicka",
    "uinv.cancel": "Återkalla",
    "uinv.sent": "Inbjudan skickad",
    "uinv.cancelled": "Inbjudan återkallad",
    "uinv.pendingOutgoing": "Skickade inbjudningar",
    "uinv.invitesTitle": "Inbjudningar till organisationer",
    "uinv.subscription": "Modell",
    "uinv.acceptBtn": "Acceptera",
    "uinv.declineBtn": "Avböj",
    "uinv.accepted": "Du har anslutit till organisationen",
    "uinv.declined": "Inbjudan avböjd",
    "uinv.modalTitle": "Hur vill du ansluta?",
    "uinv.modalHelp": "Välj om du vill ta med dina annonser, maskiner och inventarier till den nya organisationen, eller starta tomt.",
    "uinv.modeMerge": "Anslut + ta med data",
    "uinv.modeMergeHelp": "Alla dina annonser, maskiner och inventarier flyttas till den nya organisationen. Ditt personkonto tas bort om det blir tomt.",
    "uinv.modeDetach": "Anslut + starta tomt",
    "uinv.modeDetachHelp": "Du börjar fräscht i organisationen. Ditt personkonto behåller datan men kräver en ny e-post att kopplas till.",
    "uinv.newEmailPlaceholder": "Ny e-post för personkontot",
    "uinv.confirmAccept": "Bekräfta",

    // Saved
    "saved.tab": "Sparade",
    "saved.empty": "Inga sparade annonser ännu",
    "saved.emptyBody": "Tryck på hjärtat på en annons för att spara den här.",
    "saved.addToast": "Sparad",
    "saved.removeToast": "Borttagen",
    "saved.requireLogin": "Logga in för att spara annonser",

    // Ratings
    "rating.summary": "{up} tummar upp av {total}",
    "rating.none": "Inga omdömen ännu",
    "rating.thumbUp": "Tumme upp",
    "rating.thumbDown": "Tumme ned",
    "rating.rate": "Betygsätt säljaren",
    "rating.rated": "Tack för ditt omdöme!",
    "rating.alreadyRated": "Redan betygsatt",

    // Admin
    "admin.title": "Adminpanel",
    "admin.notAllowed": "Administratörsåtkomst krävs",
    "admin.tab.stats": "Statistik",
    "admin.tab.listings": "Annonser",
    "admin.tab.bookings": "Bokningar",
    "admin.tab.users": "Användare",
    "admin.tab.reports": "Rapporter",
    "admin.tab.ratings": "Omdömen",
    "admin.tab.orgs": "Organisationer",
    "admin.tab.audit": "Granskningslogg",
    "admin.tab.i18n": "Texter",
    "admin.i18n.searchPh": "Sök på nyckel eller text…",
    "admin.i18n.overrideCount": "{n} anpassningar",
    "admin.i18n.help": "Ändra UI-texter live. Tomma värden visas som tom sträng. Klicka på Återställ för att gå tillbaka till standardtexten.",
    "admin.i18n.base": "Standard",
    "admin.i18n.overridden": "Anpassad",
    "admin.i18n.save": "Spara",
    "admin.i18n.resetBtn": "Återställ",
    "admin.i18n.saved": "Sparat",
    "admin.i18n.reset": "Återställt",
    "admin.i18n.truncated": "Visar 500 av {n}. Förfina sökningen för att se fler.",
    "admin.audit.actorPh": "Filtrera på e-post…",
    "admin.audit.actionPh": "Filtrera på åtgärd…",
    "admin.audit.refresh": "Uppdatera",
    "admin.audit.exportCsv": "Exportera CSV",
    "admin.audit.exported": "CSV exporterad",
    "admin.audit.empty": "Inga händelser ännu",
    "admin.audit.by": "av",
    "admin.audit.showDetails": "Visa detaljer",
    "admin.audit.hideDetails": "Dölj detaljer",
    "admin.orgs.title": "Organisationer",
    "admin.orgs.newBtn": "Ny organisation",
    "admin.orgs.name": "Namn",
    "admin.orgs.type": "Typ",
    "admin.orgs.owner": "Ägare (email)",
    "admin.orgs.created": "Skapad",
    "admin.orgs.actions": "Åtgärder",
    "admin.orgs.edit": "Redigera",
    "admin.orgs.delete": "Ta bort",
    "admin.orgs.save": "Spara",
    "admin.orgs.cancel": "Avbryt",
    "admin.orgs.confirmDelete": "Ta bort organisationen?",
    "admin.orgs.createOk": "Organisation skapad",
    "admin.orgs.updateOk": "Organisation uppdaterad",
    "admin.orgs.deleteOk": "Organisation borttagen",
    "admin.orgs.empty": "Inga organisationer ännu",
    "admin.stats.users": "Användare",
    "admin.stats.listings": "Annonser totalt",
    "admin.stats.hidden": "Dolda annonser",
    "admin.stats.bookings": "Bokningar",
    "admin.stats.pending": "Väntande",
    "admin.stats.completed": "Slutförda",
    "admin.stats.rejected": "Avvisade",
    "admin.stats.reports": "Öppna rapporter",
    "admin.stats.ratings": "Omdömen totalt",
    "admin.stats.ratingsUp": "Positiva",
    "admin.listings.search": "Sök titel, plats eller säljare",
    "admin.hide": "Dölj",
    "admin.unhide": "Visa",
    "admin.delete": "Ta bort",
    "admin.forceStatus": "Tvinga status",
    "admin.suspend": "Stäng av",
    "admin.unsuspend": "Återaktivera",
    "admin.setRole": "Sätt roll",
    "admin.report.reason": "Anledning",
    "admin.report.resolve": "Lös rapport",
    "admin.confirmDelete": "Är du säker?",
    "admin.actionOk": "Utfört",
    "admin.hidden": "dold",
    "admin.suspended": "avstängd",
    "admin.reportBtn": "Rapportera",
    "admin.reportPrompt": "Varför rapporterar du denna annons?",
    "admin.reportSent": "Rapport skickad. Tack!",
    "admin.bulk.selected": "markerade",
    "admin.bulk.selectAll": "Markera alla",
    "admin.bulk.clear": "Rensa val",
    "admin.bulk.hide": "Dölj markerade",
    "admin.bulk.unhide": "Visa markerade",
    "admin.bulk.delete": "Ta bort markerade",
    "admin.bulk.done": "{n} annonser påverkade",
    "admin.bulk.usersDone": "{n} användare påverkade",
    "admin.bulk.suspend": "Stäng av markerade",
    "admin.bulk.unsuspend": "Återaktivera markerade",
    "admin.bulk.delete": "Radera markerade",
    "admin.bulk.confirmDelete": "Är du säker på att du vill radera {n} användare? Åtgärden kan inte ångras.",
    "admin.user.org": "Organisation",
    "admin.createUser.btn": "Skapa användare",
    "admin.createUser.title": "Skapa ny användare",
    "admin.createUser.email": "E-post",
    "admin.createUser.name": "Namn",
    "admin.createUser.password": "Lösenord",
    "admin.createUser.passwordPlaceholder": "Lämna tomt för att generera",
    "admin.createUser.role": "Roll",
    "admin.createUser.rolePending": "— välj senare —",
    "admin.createUser.org": "Organisation",
    "admin.createUser.orgPersonal": "Personlig org (skapas)",
    "admin.createUser.submit": "Skapa konto",
    "admin.createUser.created": "Användare skapad",
    "admin.createUser.tempPwTitle": "Tillfälligt lösenord (visas endast nu)",
    "admin.createUser.tempPwHelp": "Kopiera lösenordet och dela det med användaren via en säker kanal. Användaren kan ändra det vid första inloggning.",
    "admin.createUser.done": "Klar",

    // Auth
    "auth.signingIn": "[ Loggar in dig... ]",

    // Categories
    "cat.Wood": "Trä / Timmer",
    "cat.Bricks": "Tegel",
    "cat.Concrete": "Betong",
    "cat.Metal": "Metall",
    "cat.Glass": "Glas",
    "cat.Tiles": "Kakel & Klinker",
    "cat.Insulation": "Isolering",
    "cat.DoorsWindows": "Dörrar & Fönster",
    "cat.Roofing": "Tak",
    "cat.Other": "Övrigt",

    // Units
    "unit.pcs": "st",
    "unit.m": "m",
    "unit.m2": "m²",
    "unit.m3": "m³",
    "unit.kg": "kg",
    "unit.ton": "ton",
    "unit.pallet": "pall",

    // Price
    "price.currency": "kr",

    // Organisation / Driftmodell
    "org.tab": "Organisation",
    "org.title": "Organisation & Driftmodell",
    "org.label": "[ Drift ]",
    "org.name": "Organisationsnamn",
    "org.subscription": "Prenumeration",
    "org.sub.intern": "Stängd (endast intern spårning)",
    "org.sub.hybrid": "Hybrid (intern + extern överföring)",
    "org.sub.oppen": "Öppen (publik marknad)",
    "org.subShort.intern": "Stängd",
    "org.subShort.hybrid": "Hybrid",
    "org.subShort.oppen": "Öppen",
    "org.adminOnlyHint": "Endast admin kan ändra organisationens typ eller prenumeration.",
    "org.save": "Spara",
    "org.saved": "Uppdaterad",
    "org.co2eTotal": "Total CO2e-besparing",
    "org.co2ePerCat": "Per kategori",
    "org.listingsTotal": "Annonser totalt",
    "org.internal": "Interna",
    "org.external": "Externa",
    "org.published": "Publicerade",
    "org.kg": "kg CO2e",
    "org.kalla": "Källa: generisk klimatdata",
    "org.transfers": "Externa överföringar",
    "org.noTransfers": "Inga externa överföringar ännu",
    "org.newTransfer": "Logga extern överföring",
    "org.transfer.type": "Typ av överföring",
    "org.transfer.forsaljning": "Försäljning",
    "org.transfer.overlatelse": "Överlåtelse",
    "org.transfer.donation": "Donation",
    "org.transfer.receiver": "Mottagare",
    "org.transfer.date": "Datum",
    "org.transfer.create": "Registrera",
    "org.transfer.created": "Extern överföring registrerad",
    "org.transfer.failed": "Kunde inte registrera överföring",
    "org.transfer.selectListing": "Välj annons",
    "org.transfer.forbiddenIntern": "Intern-prenumeration tillåter inte externa överföringar",

    // Listing extras
    "add.ursprung": "Ursprung / projekt (valfritt)",
    "add.ursprungPh": "t.ex. rivning Hagastaden etapp 3",
    "add.destination": "Destination",
    "add.destIntern": "Intern (återanvänds internt)",
    "add.destExtern": "Extern (delas utanför organisationen)",
    "add.konto": "Kostnadsställe / konto",
    "add.kontoPh": "t.ex. 4010 – Byggprojekt Söder",
    "add.publicerad": "Publicera externt på marknadsplatsen",
    "add.publiceradHintIntern": "Intern-prenumeration: annonsen publiceras inte externt",
    "add.traceTitle": "Spårbarhet & drift",

    // Detail
    "detail.co2eSaved": "CO2e-besparing",
    "detail.co2eKalla": "generisk klimatdata",
    "detail.co2eMissingWeight": "Vikt per styck saknas — CO₂e ej beräknad",
    "detail.co2eMissingWeightHelp": "Den här annonsen är i en kategori som räknas per kilo, men enheten är inte kg/ton. För att visa klimatvinsten korrekt — gå till Redigera och fyll i vikt per styck.",

    // Role switcher
    "role.view.admin": "Visa som admin",
    "role.view.seller": "Visa som säljare",
    "role.view.buyer": "Visa som köpare",

    // Brand & top nav
    "brand.name": "ReSource Build",
    "nav.material": "Material",
    "nav.machines": "Maskiner & Verktyg",
    "nav.inventory": "Inventarier",
    "nav.projects": "Projekt",
    "nav.backToList": "← Tillbaka till lista",

    // Machines
    "mach.title": "Maskiner & Verktyg",
    "mach.label": "[ Maskinpark ]",
    "mach.new": "Ny maskin",
    "mach.namn": "Namn",
    "mach.typ": "Typ",
    "mach.plats": "Plats",
    "mach.ansvarig": "Ansvarig",
    "mach.status": "Status",
    "mach.driftstimmar": "Driftstimmar",
    "mach.serviceintervall": "Serviceintervall (h)",
    "mach.co2eKop": "Generiskt CO2e vid köp (kg)",
    "mach.co2ePerKm": "CO2e transport per km (kg)",
    "mach.bookBtn": "Boka maskin",
    "mach.calendar": "Kalender",
    "mach.empty": "Inga maskiner ännu",
    "mach.statusTillganglig": "Tillgänglig",
    "mach.statusBokad": "Bokad",
    "mach.statusUtlamnad": "Utlämnad",
    "mach.statusService": "Service",
    "mach.statusTrasig": "Trasig",
    "mach.created": "Maskin skapad",
    "mach.updated": "Maskin uppdaterad",
    "mach.newTitle": "Ny maskin / verktyg",
    "mach.editTitle": "Redigera maskin / verktyg",
    "mach.updated": "Maskin uppdaterad",
    "mach.deleted": "Maskin borttagen",
    "mach.confirmDelete": "Ta bort denna maskin?",

    // Inventory
    "inv.title": "Inventarier",
    "inv.label": "[ Inventarie­förråd ]",
    "inv.new": "Nytt inventarium",
    "inv.namn": "Namn",
    "inv.typ": "Typ (t.ex. hjälm, sele, mätinstrument)",
    "inv.plats": "Plats",
    "inv.status": "Status",
    "inv.statusLedig": "Ledig",
    "inv.statusUte": "Utlånad",
    "inv.statusTrasig": "Trasig",
    "inv.empty": "Inga inventarier ännu",
    "inv.history": "Historik",
    "inv.created": "Inventarium skapat",
    "inv.newTitle": "Nytt inventarium",
    "inv.editTitle": "Redigera inventarium",
    "inv.updated": "Inventarium uppdaterat",
    "inv.deleted": "Inventarium borttaget",

    // Projects
    "prj.title": "Projekt",
    "prj.label": "[ Projektregister ]",
    "prj.new": "Nytt projekt",
    "prj.namn": "Projektnamn",
    "prj.plats": "Plats",
    "prj.ansvarig": "Ansvarig",
    "prj.beskrivning": "Beskrivning",
    "prj.empty": "Inga projekt ännu",
    "prj.attach": "Lägg till i projekt",
    "prj.detach": "Ta bort från projekt",
    "prj.attached": "Tillagd i projekt",
    "prj.attachedTo": "Kopplad till {name}",
    "prj.detached": "Koppling borttagen",
    "prj.linkedTo": "Kopplad till",
    "prj.linkedBadge": "KOPPLAD",
    "prj.changeLink": "Byt projekt",
    "prj.removeLink": "Ta bort koppling",
    "prj.pickProject": "Välj ett projekt…",
    "prj.noneYet": "Inga projekt ännu — skapa ett under Projekt först",
    "prj.unknownProject": "(okänt projekt)",
    "prj.linked": "Kopplade objekt",
    "prj.linkedNone": "Inga kopplade objekt ännu",
    "prj.created": "Projekt skapat",
    "prj.updated": "Projekt uppdaterat",
    "prj.deleted": "Projekt borttaget",
    "prj.selectProject": "Välj projekt",

    // Machine booking
    "mbk.title": "Maskinbokningar",
    "mbk.start": "Start",
    "mbk.slut": "Slut",
    "mbk.transportKm": "Transportsträcka (km tur+retur)",
    "mbk.note": "Anteckning",
    "mbk.book": "Boka",
    "mbk.created": "Bokning skapad",
    "mbk.collision": "Maskinen är redan bokad i detta tidsspann",
    "mbk.cal.title": "Bokad i denna kalender",
    "mbk.cal.allFree": "Maskinen är ledig — välj valfri tid",
    "mbk.cal.freeFrom": "Tillgänglig från",
    "mbk.cal.jumpBtn": "Använd denna tid",
    "mbk.cal.conflict": "Krockar med befintlig bokning",
    "mbk.cal.booked": "Bokad",
    "mbk.cal.out": "Ute",
    "mbk.approve": "Godkänn",
    "mbk.pickup": "Markera utlämnad",
    "mbk.return": "Markera återlämnad",
    "mbk.cancel": "Avbryt bokning",
    "mbk.statusBokad": "Bokad",
    "mbk.statusGodkand": "Godkänd",
    "mbk.statusUtlamnad": "Utlämnad",
    "mbk.statusAterlamnad": "Återlämnad",
    "mbk.statusAvbruten": "Avbruten",
    "mbk.savings": "CO2e-besparing",
    "mbk.savingsCompare": "Jämfört med att köpa nytt",
    "mbk.empty": "Inga bokningar",

    // QR
    "qr.title": "QR-kod",
    "qr.scanHint": "Skanna för att öppna detaljsidan (kräver inloggning)",
    "qr.copyLink": "Kopiera länk",
    "qr.linkCopied": "Länk kopierad",
    "qr.modeDetail": "Detaljsida",
    "qr.modeQuickBook": "Snabbboka",
    "qr.scanHintQuickBook": "Skanna för att snabbboka maskinen",
    "qr.scanHintQuickBookMaterial": "Skanna för att snabbta materialet från lager",
    "qr.show": "Visa QR-kod",
    "qr.hide": "Dölj QR-kod",

    // Material quick-take (QR scan)
    "lqb.heading": "Snabbtag från lager",
    "lqb.available": "Tillgängligt: {qty} {unit}",
    "lqb.bokare": "Vem tar materialet?",
    "lqb.bokarePh": "Ditt namn",
    "lqb.qty": "Hur mycket tar du?",
    "lqb.qtyHint": "Ange en giltig mängd",
    "lqb.qtyOver": "Max tillgängligt är {max} {unit}",
    "lqb.project": "Projekt (valfritt)",
    "lqb.projectNone": "Inget projekt",
    "lqb.method": "Hur tar du materialet?",
    "lqb.pickup": "Hämta nu",
    "lqb.delivery": "Leverans",
    "lqb.submit": "Bekräfta tag",
    "lqb.submitting": "Skickar…",
    "lqb.failed": "Kunde inte skapa bokning",
    "lqb.successTitle": "Klart!",
    "lqb.successBody": "Du tog {qty} {unit} av \"{title}\". Bokningen är registrerad.",
    "lqb.bookAnother": "Ny snabbtag",
    "lqb.viewDetail": "Öppna materialsidan",
    "qr.export": "Exportera",
    "qr.exporting": "Exporterar…",
    "qr.exportPng": "PNG-bild",
    "qr.exportPdf": "PDF-utskrift",
    "qr.exportZpl": "ZPL (Zebra-etikett)",
    "qr.exportOk": "{kind} nedladdad",
    "qr.exportFailed": "Export misslyckades — försök igen",
    "qr.printNow": "Skriv ut nu",
    "qr.printing": "Skriver ut…",
    "qr.printSent": "Skickat till {printer}",
    "qr.printFailed": "Utskrift misslyckades",
    "qr.copies": "Antal kopior",

    // Printers (org settings)
    "printer.title": "Nätverksskrivare",
    "printer.subtitle": "Konfigurera Zebra-etikettskrivare i ditt nätverk. När en skrivare är aktiv kan du skriva ut QR-etiketter direkt från en maskin- eller inventariesida med ett klick.",
    "printer.empty": "Inga skrivare konfigurerade ännu",
    "printer.default": "Standard",
    "printer.test": "Testa",
    "printer.testOk": "Skrivaren svarar — anslutning OK",
    "printer.testFail": "Skrivaren svarar inte: {err}",
    "printer.makeDefault": "Sätt som standard",
    "printer.add": "Lägg till skrivare",
    "printer.namePh": "Namn (t.ex. Depå Stockholm)",
    "printer.hostPh": "IP eller hostname (t.ex. 192.168.10.50)",
    "printer.portPh": "Port (vanligtvis 9100)",
    "printer.notePh": "Anteckning (valfritt)",
    "printer.markDefault": "Använd som standardskrivare för organisationen",
    "printer.help": "Använder Zebras raw TCP-protokoll på port 9100. Funkar med alla Zebra GK/ZD/ZT-modeller.",
    "printer.created": "Skrivare tillagd",
    "printer.createFailed": "Kunde inte lägga till skrivaren",
    "printer.updateFailed": "Kunde inte uppdatera skrivaren",
    "printer.deleteFailed": "Kunde inte ta bort skrivaren",
    "printer.loadFailed": "Kunde inte ladda skrivare",
    "printer.confirmDelete": "Ta bort skrivaren \"{name}\"?",

    // Quick book
    "qb.title": "Snabbboka",
    "qb.subtitle": "Tre frågor — sen är du bokad",
    "qb.q1": "Vem ska använda maskinen?",
    "qb.q1Hint": "Skriv ditt eller en kollegas namn",
    "qb.q2": "Var ska maskinen användas?",
    "qb.q2Project": "Projekt",
    "qb.q2Location": "Plats / arbetsställe",
    "qb.q3": "Hur länge?",
    "qb.duration2h": "2 tim",
    "qb.duration4h": "4 tim",
    "qb.duration8h": "8 tim",
    "qb.duration1d": "1 dag",
    "qb.duration3d": "3 dagar",
    "qb.duration1w": "1 vecka",
    "qb.durationCustom": "Eget antal timmar",
    "qb.confirm": "Bekräfta bokning",
    "qb.success": "Maskin bokad!",
    "qb.successDetail": "Bokningen är registrerad. Du hittar den under maskinens detaljsida.",
    "qb.bookAnother": "Boka en till",
    "qb.viewDetail": "Visa maskindetaljer",
    "qb.summary": "Sammanfattning",
    "qb.from": "Från",
    "qb.to": "Till",

    // CO2e Dashboard
    "nav.co2e": "CO2e",
    "co2eDash.label": "[ Klimatöversikt ]",
    "co2eDash.title": "CO2e-besparing",
    "co2eDash.subtitle": "Sammanställning av besparingar från återbrukat material och delade maskiner.",
    "co2eDash.totalSaved": "Total besparing",
    "co2eDash.materialSaved": "Material",
    "co2eDash.machineSaved": "Maskiner (hyra)",
    "co2eDash.projects": "Projekt",
    "co2eDash.overTime": "CO2e sparat över tid",
    "co2eDash.perCategory": "CO2e per kategori",
    "co2eDash.perProject": "CO2e per projekt",
    "co2eDash.hyraVsKop": "Hyra vs. köpa nytt",
    "co2eDash.kop": "Om köpt nytt",
    "co2eDash.hyra": "Faktisk hyra",
    "co2eDash.besparing": "Total besparing",
    "co2eDash.top10Machines": "Topp 10 maskiner",
    "co2eDash.top10Materials": "Topp 10 material",
    "co2eDash.noProjects": "Inga projekt med besparing ännu",
    "co2eDash.noMachines": "Inga maskiner med bokningar ännu",
    "co2eDash.noMaterials": "Inga material­annonser ännu",
    "co2eDash.kalla": "Källa: generisk klimatdata · CO2e_besparing = CO2e_köp − (transport + 1 kg underhåll)",

    // Landing page
    "ld.hero.label": "[ ReSource Build · Cirkulär tillgångsplattform ]",
    "ld.hero.title1": "Den kompletta",
    "ld.hero.title2": "cirkulära plattformen",
    "ld.hero.title3": "för bygg­branschen",
    "ld.hero.subBefore": "Hantera, dela och återbruka allt din bygg­organisation äger —",
    "ld.hero.subBold": "material, maskiner, verktyg och förråds­inventarier.",
    "ld.hero.subAfter": " En plattform. Verklig CO₂e-effekt. Synlig från dag ett.",
    "ld.hero.browse": "Bläddra i material",
    "ld.hero.explore": "Utforska plattformen",
    "ld.hero.liveLabel": "[ Live nu ]",
    "ld.hero.liveText": "Material · Maskiner · Inventarier · Projekt",
    "ld.stat.tons": "Ton återvunnet",
    "ld.stat.sellers": "Aktiva säljare",
    "ld.stat.cities": "Städer live",

    "ld.value.label": "[ 01 · Varför det här finns ]",
    "ld.value.title1": "Mer än en marknadsplats —",
    "ld.value.title2": "ett komplett tillgångssystem",
    "ld.value.title3": "för byggbranschen",
    "ld.value.body": "Bygg är världens största material­konsument — och en av de största avfalls­producenterna. De flesta tillgångar står oanvända i förråd eller slängs när projekt avslutas. ReSource Build löser det genom att kombinera sex flöden i en plattform:",
    "ld.value.p1": "Material­återbruk",
    "ld.value.p2": "Maskin- & verktygs­bokning",
    "ld.value.p3": "Inventarie­hantering",
    "ld.value.p4": "Projekt­koppling",
    "ld.value.p5": "CO₂e-beräkning",
    "ld.value.p6": "Fordons­flotta & utsläpps­rapporter",

    "ld.feat.label": "[ 02 · De fem byggstenarna ]",
    "ld.feat.title1": "Varje tillgång i din organisation, på",
    "ld.feat.title2": "en plats",
    "ld.feat.aTitle": "Material­marknad",
    "ld.feat.aKicker": "Återbruka det andra slänger",
    "ld.feat.a1": "Återbruks­annonser med foton, kvalitetsklass och mängd",
    "ld.feat.a2": "Intern eller extern synlighet per organisation",
    "ld.feat.a3": "Live lager­status (st / m² / lpm)",
    "ld.feat.a4": "Automatisk CO₂e per material baserat på generisk klimat­data",
    "ld.feat.a5": "Boknings­flöde för upphämtning eller leverans",
    "ld.feat.aCta": "Bläddra i marknaden",

    "ld.feat.bTitle": "Maskiner & verktyg",
    "ld.feat.bKicker": "Dela istället för att dubbel­köpa",
    "ld.feat.b1": "Kalender­bokning med kollisions­kontroll",
    "ld.feat.b2": "Driftstimmar och service­intervall",
    "ld.feat.b3": "QR-koder för skanna-och-snabb­boka",
    "ld.feat.b4": "Godkänn → utlämna → återlämna",
    "ld.feat.b5": "CO₂e-besparing: hyra vs. köpa nytt, beräknat per bokning",
    "ld.feat.bCta": "Visa maskiner",

    "ld.feat.cTitle": "Inventarie­hantering",
    "ld.feat.cKicker": "Byggbodar, ställningar, skyltar m.m.",
    "ld.feat.c1": "Spåra byggbodar, containrar, ställningar, skyddsutrustning, skyltar",
    "ld.feat.c2": "Status: ledig · ute · trasig — med full historik",
    "ld.feat.c3": "Plats vid varje skede i varje projekt",
    "ld.feat.c4": "QR-taggar för direkt skanna-och-hitta",
    "ld.feat.c5": "Kopplat till ansvarig person och projekt",
    "ld.feat.cCta": "Visa inventarier",

    "ld.feat.dTitle": "Projekt & organisation",
    "ld.feat.dKicker": "Struktur, roller, synlighet",
    "ld.feat.d1": "Koppla valfri tillgång (material, maskin, inventarie) till ett projekt",
    "ld.feat.d2": "Organisations­roller: admin, säljare, köpare",
    "ld.feat.d3": "Avdelningar, ägar­e-post, prenumerations­nivå",
    "ld.feat.d4": "Stängd / Hybrid / Öppen marknad per organisation",
    "ld.feat.d5": "Aggregerad klimat­påverkan över alla projekt",
    "ld.feat.dCta": "Visa projekt",

    "ld.feat.eTitle": "Fordon & flotta",
    "ld.feat.eKicker": "Utsläpp per fordon. Per projekt. Per period.",
    "ld.feat.eLead": "Få full kontroll på flottans CO₂-avtryck — automatiskt, individuellt och rapporterbart.",
    "ld.feat.e1": "Individuella utsläppsrapporter per fordon — diesel, bensin, HVO, el, hybrid",
    "ld.feat.e2": "Aggregera CO₂ på projektnivå för enkel kundredovisning",
    "ld.feat.e3": "Periodvisa rapporter: månad, kvartal, år — exporterbara för revision",
    "ld.feat.e4": "Auto-påminnelser för besiktning och service — aldrig mer förseningar",
    "ld.feat.e5": "Släpvagnar, uthyrnings­rapportering och auto-faktura­underlag vid återlämning",
    "ld.feat.eCta": "Utforska fordon",
    "ld.feat.eBadge": "Nytt 2026",

    "ld.collab.label": "[ 04 · Samarbete & nätverk ]",
    "ld.collab.title1": "Logga ditt material.",
    "ld.collab.title2": "Bygg ditt nätverk.",
    "ld.collab.title3": "Dela smartare.",
    "ld.collab.lead": "Plattformen blir starkare ju fler du delar med. Bjud in dina partners, leverantörer och underentreprenörer — och förvandla deras lager till en förlängning av ditt eget.",
    "ld.collab.s1Title": "Logga",
    "ld.collab.s1Body": "Material, maskiner och inventarier registreras en gång — synliga för dig direkt och redo att delas när du vill.",
    "ld.collab.s2Title": "Anslut",
    "ld.collab.s2Body": "Skicka inbjudningar till partner-organisationer. När de accepterar öppnas ett delat nätverk där ni ser varandras tillgångar.",
    "ld.collab.s3Title": "Dela",
    "ld.collab.s3Body": "Boka eller köp direkt mellan organisationer — ni behåller kontrollen över vad som visas, för vem och till vilket pris.",
    "ld.collab.b1": "Stängt, hybrid eller öppet — du väljer synlighet per resurs",
    "ld.collab.b2": "Inbjudningar via e-post, automatiska för samma domän",
    "ld.collab.b3": "Boka i partner-org utan att lämna plattformen",
    "ld.collab.b4": "All aktivitet loggad — full revisionsspårning",
    "ld.collab.cta": "Bygg ditt nätverk",

    "ld.dash.label": "[ 05 · CO₂e-dashboard ]",
    "ld.dash.title1": "Klimat­påverkan",
    "ld.dash.title2": "synliggjord",
    "ld.dash.body": "ReSource Build beräknar automatiskt CO₂e-besparingar från varje åter­brukat material, varje delad maskin och varje undviken transport. Generiska klimat­faktorer är inbakade — inga kalkyl­blad, inga konsulter.",
    "ld.dash.p1": "Total CO₂e-besparing, hela organisationen",
    "ld.dash.p2": "Per projekt, per månad, per kategori",
    "ld.dash.p3": "Topp 10 maskiner och material som sparar mest",
    "ld.dash.p4": "Hyra vs. köpa-jämförelse — stapel för stapel",
    "ld.dash.cta": "Se dashboarden",
    "ld.dash.mockTotal": "kg CO₂e totalt",
    "ld.dash.mockBookings": "bokningar",
    "ld.dash.mockProjects": "projekt",
    "ld.dash.months": "J,F,M,A,M,J,J,A,S,O,N,D",
    "ld.dash.rentVsBuy": "Hyra vs köpa",
    "ld.dash.buy": "Köpa nytt",
    "ld.dash.rent": "Hyra",
    "ld.dash.topMach": "Topp maskiner",

    "ld.why.label": "[ 06 · Varför ReSource Build ]",
    "ld.why.title1": "Fyra utfall,",
    "ld.why.title2": "en plattform",
    "ld.why.aTitle": "Sänk kostnader",
    "ld.why.aBody": "Undvik dubbel­köp, sälj överskott, dela tillgångar mellan avdelningar och projekt. Betala bara för det ni faktiskt behöver.",
    "ld.why.bTitle": "Sänk CO₂e",
    "ld.why.bBody": "Automatisk utsläpps­spårning från generisk klimat­data — varje åter­bruk och uthyrning bidrar till ett mätbart, redovisnings­bart resultat.",
    "ld.why.cTitle": "Öka kontrollen",
    "ld.why.cBody": "Varje maskin, varje inventarie, varje kilo material — med status, plats, historik och ansvarig person.",
    "ld.why.dTitle": "Öka samarbetet",
    "ld.why.dBody": "Avdelningar, projekt och organisationer delar via en konsekvent plattform. Inga fler Excel-blad, WhatsApp-trådar eller borttappade mejl.",

    "ld.how.label": "[ 07 · Så funkar det ]",
    "ld.how.title1": "Igång på",
    "ld.how.title2": "fyra steg",
    "ld.how.s1Title": "Lägg till tillgångar",
    "ld.how.s1Body": "Material, maskiner, verktyg och inventarier — bulk eller en åt gången. Foton, platser, typer.",
    "ld.how.s2Title": "Organisera projekten",
    "ld.how.s2Body": "Skapa projekt och koppla tillgångar. Välj prenumeration: stängd, hybrid eller öppen marknad.",
    "ld.how.s3Title": "Dela eller sälj",
    "ld.how.s3Body": "Interna kollegor kan boka maskiner. Externa köpare kan hämta material. QR-koder överallt.",
    "ld.how.s4Title": "Spåra CO₂e-besparing",
    "ld.how.s4Body": "Dashboarden uppdateras i realtid när bokningar och åter­bruk sker. Exportera till hållbarhets­rapporten.",

    "ld.price.label": "[ 06 · Prisnivåer ]",
    "ld.price.title1": "Välj modellen som",
    "ld.price.title2": "passar er drift",
    "ld.price.openTier": "Öppen marknad",
    "ld.price.openPrice": "Gratis",
    "ld.price.openTag": "Publika annonser, publika köpare",
    "ld.price.o1": "Lägg till obegränsat antal material­annonser",
    "ld.price.o2": "Publik synlighet på marknaden",
    "ld.price.o3": "Grundläggande CO₂e per annons",
    "ld.price.o4": "E-postsupport",
    "ld.price.openCta": "Kom igång",
    "ld.price.hybridTier": "Hybrid",
    "ld.price.hybridPrice": "Rekommenderad",
    "ld.price.hybridTag": "Intern delning + extern handel",
    "ld.price.h1": "Allt i Öppen",
    "ld.price.h2": "Maskin- & inventarie­spårning",
    "ld.price.h3": "Interna projekt & roller",
    "ld.price.h4": "Logg för externa över­föringar",
    "ld.price.h5": "Full CO₂e-dashboard med export",
    "ld.price.h6": "Prioriterad support",
    "ld.price.hybridCta": "Testa Hybrid",
    "ld.price.entTier": "Stängd Enterprise",
    "ld.price.entPrice": "Premium",
    "ld.price.entTag": "Endast intern, full revision",
    "ld.price.e1": "Allt i Hybrid",
    "ld.price.e2": "Endast intern marknad",
    "ld.price.e3": "Avancerade roller & behörigheter",
    "ld.price.e4": "Audit log & SSO",
    "ld.price.e5": "Dedikerad kund­ansvarig",
    "ld.price.e6": "SLA & onboarding",
    "ld.price.entCta": "Kontakta sälj",

    "ld.cta.label": "[ Klart när ni är ]",
    "ld.cta.title1": "Börja använd ReSource Build",
    "ld.cta.title2": "idag",
    "ld.cta.body": "Bygg­bolag, kommuner och regioner i hela landet skär redan ner avfall, kostnader och CO₂e — synligt. Ni kan vara igång på en eftermiddag.",
    "ld.cta.start": "Kom igång",
    "ld.cta.demo": "Boka demo",

    "ld.trust.firms": "Bygg­bolag",
    "ld.trust.muni": "Kommuner",
    "ld.trust.regions": "Regioner",
    "ld.trust.openData": "Öppen data, generisk CO₂e",

    // Collaboration (inter-org)
    "collab.title": "Samarbeten",
    "collab.inviteBtn": "Bjud in",
    "collab.targetEmail": "E-post till org-admin",
    "collab.send": "Skicka inbjudan",
    "collab.invited": "Inbjudan skickad",
    "collab.incoming": "Inkommande inbjudningar",
    "collab.outgoing": "Skickade inbjudningar",
    "collab.accept": "Acceptera",
    "collab.accepted": "Accepterade samarbeten",
    "collab.decline": "Avböj",
    "collab.declined": "Inbjudan avböjd",
    "collab.cancelInvite": "Återkalla",
    "collab.removed": "Samarbete borttaget",
    "collab.removeConfirm": "Ta bort detta samarbete?",
    "collab.noneYet": "Inga samarbeten ännu",

    // Visibility picker — användarvänliga texter (UX-refaktor)
    "vis.title": "Vem ser detta?",
    "vis.lead": "Välj vem som kan se denna resurs.",
    "vis.internal": "Intern",
    "vis.shared": "Delad",
    "vis.public": "Publik",
    "vis.internal.title": "Endast min organisation",
    "vis.shared.title": "Dela med partners",
    "vis.public.title": "Publik marknadsplats",
    "vis.internal.hint": "Endast ditt team kan se detta",
    "vis.shared.hint": "Synlig för organisationer du samarbetar med",
    "vis.shared.helper": "Du kan ändra detta senare",
    "vis.public.hint": "Synlig utanför din organisation",
    "vis.selected": "Vald",
    "vis.status.label": "Just nu",
    "vis.status.internal": "Endast ditt team kan se detta",
    "vis.status.public": "Synlig utanför din organisation",
    "vis.status.sharedAll": "Synlig för alla {n} samarbetspartners",
    "vis.status.sharedSome": "Synlig för {n} valda partners",
    "vis.status.sharedNone": "Inga samarbeten ännu — endast ditt team ser detta",
    "vis.shared.noCollabs": "Du har inga samarbeten ännu. Bjud in en partner-org under \"Min org\" först — sen kan du dela resurser med dem.",
    "vis.advanced.toggle": "Avancerat: välj specifika partners",
    "vis.advanced.hint": "Lämna alla omarkerade för att dela med ALLA samarbeten (rekommenderas). Välj specifika för att begränsa.",
    "vis.advanced.clear": "Rensa val (dela med alla)",
    "vis.sell.title": "Denna resurs blir synlig externt",
    "vis.sell.question": "Vill du sälja den eller ge bort den?",
    "vis.sell.sell": "Sälj",
    "vis.sell.giveaway": "Ge bort (gratis)",
    "vis.sell.giveawayHint": "Priset sätts till 0 — alla kan hämta den gratis.",
    "vis.sell.pickOne": "Välj sälj eller ge bort först",
    "vis.sell.cancel": "Avbryt",
    "vis.sell.priceLabel": "Ange pris",
    "vis.sell.confirm": "Bekräfta pris",
    "vis.sell.invalidPrice": "Ange ett pris större än 0",
    "vis.sharedWithLabel": "Dela med specifika samarbeten",
    "vis.sharedAllHint": "Lämna tomt för att dela med alla samarbeten.",
    "vis.save": "Spara",
    "vis.saved": "Synlighet sparad",
    "vis.externalTag": "Extern resurs",
    "vis.sharedTag": "Delad",
    "vis.publicTag": "Publik",
    // Next-actions panel (after save)
    "next.title": "Vad vill du göra härnäst?",
    "next.lead": "Sparat. Välj nästa steg.",
    "next.addNew": "Lägg till ny",
    "next.viewAll": "Visa alla",
    "next.assignProject": "Koppla till projekt",
    "next.share": "Dela eller publicera",
    // Resource transfer (booking → buyer's resources)
    "transfer.title": "Material redo att tas emot",
    "transfer.question": "Vill du lägga till detta material i din organisations resurser?",
    "transfer.yes": "Ja, lägg till",
    "transfer.no": "Nej",
    "transfer.success": "Materialet har lagts till i din organisation",
    "transfer.addedTag": "Tillagt i resurser",
    // Unified status labels across materials / machines / inventory
    "status.machine.available": "Tillgänglig",
    "status.machine.booked": "Bokad",
    "status.machine.inUse": "Utlämnad",
    "status.machine.service": "Service",
    "status.machine.broken": "Trasig",
    "status.inv.available": "Tillgänglig",
    "status.inv.checkedOut": "Utlämnad",
    "status.mat.available": "Tillgänglig",
    "status.mat.reserved": "Reserverad",
    "status.mat.completed": "Slutförd",

    // Login / Register (email + password fallback)
    "login.title": "Logga in",
    "login.registerTitle": "Skapa konto",
    "login.subtitle": "Använd e-post & lösenord eller fortsätt med Google.",
    "login.tabLogin": "Logga in",
    "login.tabRegister": "Registrera",
    "login.email": "E-post",
    "login.password": "Lösenord",
    "login.passwordHint": "Minst 8 tecken",
    "login.name": "Namn",
    "login.submit": "Logga in",
    "login.registerSubmit": "Skapa konto",
    "login.or": "eller",
    "login.google": "Fortsätt med Google",
    "login.welcomeBack": "Välkommen tillbaka",
    "login.created": "Konto skapat",
    "login.chooseTitle": "Välj inloggningsmetod",
    "login.chooseSubtitle": "Logga in med Google för snabb åtkomst, eller med e-post & lösenord.",
    "login.googleTitle": "Logga in med Google",
    "login.googleHint": "En-klicks inloggning via ditt Google-konto.",
    "login.emailTitle": "E-post & lösenord",
    "login.emailHint": "Använd ett konto du registrerar här. Funkar även om Google blockerar.",
    "login.continue": "Fortsätt",
    "login.backToMethods": "Tillbaka till val",
    "login.turnstile.label": "Säkerhetsverifiering",
    "login.turnstile.required": "Vänligen slutför säkerhetsverifieringen ovan",
    "login.forgotPassword": "Glömt lösenord?",

    // Forgot/Reset Password
    "forgot.requestTitle": "Glömt lösenord",
    "forgot.requestSubtitle": "Ange din e-post så skickar vi en länk för att återställa lösenordet.",
    "forgot.requestSubmit": "Skicka återställningslänk",
    "forgot.sentTitle": "E-post skickat",
    "forgot.sentBody": "Om e-posten finns i systemet har vi skickat en länk för att återställa lösenordet. Länken är giltig i 30 minuter. Kontrollera även skräppost-mappen.",
    "forgot.resetTitle": "Välj nytt lösenord",
    "forgot.resetSubtitle": "Skriv in ditt nya lösenord nedan.",
    "forgot.newPassword": "Nytt lösenord",
    "forgot.confirmPassword": "Bekräfta lösenord",
    "forgot.resetSubmit": "Spara lösenord",
    "forgot.resetOk": "Lösenord uppdaterat. Logga in med ditt nya lösenord.",
    "forgot.mismatch": "Lösenorden matchar inte",
    "nav.menu": "Meny",
    // Vehicles module
    "nav.vehicles": "Fordon",
    "veh.title": "Fordon",
    "veh.label": "[ Fordonsflotta ]",
    "veh.tab.overview": "Översikt",
    "veh.tab.all": "Alla fordon",
    "veh.tab.inspections": "Besiktningar",
    "veh.tab.services": "Service",
    "veh.tab.co2": "CO₂-rapporter",
    "veh.tab.documents": "Dokument",
    "veh.new": "Nytt fordon",
    "veh.regnr": "Registreringsnummer",
    "veh.brand": "Märke",
    "veh.model": "Modell",
    "veh.year": "Årsmodell",
    "veh.fueltype": "Drivmedel",
    "veh.consumption": "Förbrukning (L eller kWh / 100 km)",
    "veh.odometer": "Mätarställning (km)",
    "veh.responsible": "Ansvarig",
    "veh.responsiblePh": "Välj ansvarig användare",
    "veh.inspectionOrg": "Besiktningsorgan",
    "veh.workshop": "Verkstad",
    "veh.nextInspection": "Nästa besiktning",
    "veh.nextService": "Nästa service",
    "veh.status": "Status",
    "veh.notes": "Anteckningar",
    "veh.documents": "Dokument",
    "veh.empty": "Inga fordon ännu",
    "veh.created": "Fordon registrerat",
    "veh.updated": "Fordon uppdaterat",
    "veh.deleted": "Fordon borttaget",
    "veh.confirmDelete": "Ta bort detta fordon? Alla besiktningar, service och CO₂-data tas också bort.",
    "veh.duplicate": "Ett fordon med detta regnr finns redan",
    "veh.status.aktiv": "Aktivt",
    "veh.status.service": "På service",
    "veh.status.ur_drift": "Ur drift",
    "veh.status.salt": "Sålt",
    "veh.fuel.diesel": "Diesel",
    "veh.fuel.bensin": "Bensin",
    "veh.fuel.el": "El",
    "veh.fuel.hvo": "HVO",
    "veh.fuel.hybrid": "Hybrid",
    "veh.fuel.gas": "Gas",
    "veh.history": "Historik",
    "veh.bookInspection": "Boka besiktning",
    "veh.bookService": "Boka service",
    "veh.markDone": "Markera klar",
    "veh.uploadProtocol": "Ladda upp protokoll",
    "veh.uploaded": "Dokument uppladdat",
    "veh.detach": "Ta bort",
    "veh.outOfCompliance": "Ej i tid",
    "veh.info": "Information",
    "veh.lastInspection": "Senaste besiktning",
    "veh.lastService": "Senaste service",
    "veh.noLast": "Ingen tidigare",
    "veh.km": "km",
    "veh.kr": "kr",

    // Inspections subpage
    "vins.title": "Besiktningar",
    "vins.upcoming": "Kommande besiktningar",
    "vins.all": "Alla besiktningar",
    "vins.date": "Datum",
    "vins.result": "Resultat",
    "vins.pass": "Godkänd",
    "vins.fail": "Underkänd",
    "vins.pending": "Bokad",
    "vins.markPass": "Markera godkänd",
    "vins.markFail": "Markera underkänd",
    "vins.bookNew": "Boka ny besiktning",
    "vins.reinspection": "Ombesiktning",
    "vins.nextDate": "Nästa besiktningsdatum",
    "vins.createdReinspection": "Ombesiktning skapad inom 30 dagar",
    "vins.empty": "Inga besiktningar",

    // Services subpage
    "vsvc.title": "Service",
    "vsvc.upcoming": "Kommande service",
    "vsvc.all": "All service",
    "vsvc.type": "Servicetyp",
    "vsvc.type.regular": "Ordinarie service",
    "vsvc.type.tire": "Däckbyte",
    "vsvc.type.repair": "Reparation",
    "vsvc.type.inspection_prep": "Inför besiktning",
    "vsvc.cost": "Kostnad",
    "vsvc.completed": "Utförd",
    "vsvc.markCompleted": "Markera utförd",
    "vsvc.bookNew": "Boka ny service",
    "vsvc.empty": "Ingen service planerad",

    // CO2 reports
    "vco2.title": "CO₂-rapporter",
    "vco2.subtitle": "Per fordon, projekt och period — beräknat på drivmedel och körsträcka",
    "vco2.period": "Period",
    "vco2.period.month": "Månad",
    "vco2.period.quarter": "Kvartal",
    "vco2.period.year": "År",
    "vco2.distance": "Sträcka (km)",
    "vco2.fuelUsed": "Drivmedel använt",
    "vco2.co2": "CO₂e (kg)",
    "vco2.project": "Projekt",
    "vco2.addRecord": "Logga körning",
    "vco2.empty": "Inga CO₂-poster ännu",
    "vco2.month": "Denna månad",
    "vco2.quarter": "Detta kvartal",
    "vco2.year": "I år",
    "vco2.perProject": "CO₂ per projekt",
    "vco2.topVehicles": "Topp utsläppare",
    "vco2.trend": "CO₂ över tid",
    "vco2.kgCO2": "kg CO₂e",
    "vco2.allVehicles": "Alla fordon",
    "vco2.allProjects": "Alla projekt",
    "vco2.aggregated": "CO₂-post sparad",

    // Reminders
    "vrem.title": "Påminnelser",
    "vrem.due": "Förfaller",
    "vrem.type.inspection": "Besiktning",
    "vrem.type.service": "Service",
    "vrem.type.reinspection": "Ombesiktning",
    "vrem.empty": "Inga kommande påminnelser",

    // Vehicle dashboard widgets
    "vdash.upcomingInspections": "Kommande besiktningar",
    "vdash.upcomingServices": "Kommande service",
    "vdash.outOfCompliance": "Fordon ej i tid",
    "vdash.activeReminders": "Aktiva påminnelser",
    "vdash.totalVehicles": "Fordon totalt",
    "vdash.viewAll": "Visa alla →",
    "vdash.noData": "Ingen data ännu",
    "vdash.filter.period": "Period",
    "vdash.filter.project": "Projekt",
    "vdash.filter.vehicle": "Fordon",

    // Notifications - vehicle reminders
    "notif.vehicle_inspection_due": "Besiktning av {regnr} förfaller {due}",
    "notif.vehicle_service_due": "Service av {regnr} förfaller {due}",
    "notif.vehicle_reinspection_due": "Ombesiktning av {regnr} förfaller {due}",

    // Bulk import (CSV/XLSX)
    "bulk.title.vehicles": "Importera fordon (CSV/XLSX)",
    "bulk.title.adminUsers": "Importera användare (CSV/XLSX)",
    "bulk.title.orgInvites": "Bjud in användare i bulk (CSV/XLSX)",
    "bulk.desc.vehicles": "Ladda upp en CSV- eller Excel-fil med fordon. Befintliga regnr inom din organisation uppdateras, nya skapas. Tomma fält ignoreras. Max 1 000 rader per import.",
    "bulk.desc.adminUsers": "Ladda upp en CSV/Excel-fil med användare. Befintliga e-postadresser hoppas över. Tillfälliga lösenord genereras och mejlas (om Resend är konfigurerad).",
    "bulk.desc.orgInvites": "Ladda upp en CSV/Excel-fil med kollegor som ska bjudas in till din organisation. De får ett mejl och kan acceptera när de loggar in.",
    "bulk.downloadTemplate": "Ladda ner mall",
    "bulk.import": "Importera CSV",
    "bulk.dropHint": "Släpp fil här, eller klicka för att välja",
    "bulk.upload": "Importera",
    "bulk.uploading": "Importerar…",
    "bulk.uploadAnother": "Importera till",
    "bulk.created": "Skapade",
    "bulk.updated": "Uppdaterade",
    "bulk.skipped": "Hoppade över",
    "bulk.invited": "Inbjudna",
    "bulk.errors": "Fel",
    "bulk.errorsTitle": "Fel per rad",
    "bulk.row": "Rad",
    "bulk.tempPasswords": "Tillfälliga lösenord (visas endast nu)",
    "bulk.tempPasswordsHelp": "Skickade via e-post. Kopiera nu om Resend inte är konfigurerad.",

    // Rental reporting + Trailers
    "rental.toggle": "Aktivera uthyrningsrapportering (kundjobb)",
    "rental.toggleHelp": "När aktiverad krävs projekt och ansvarig användare vid bokning. När resursen återlämnas skapas automatiskt en sammanfattning som mejlas till organisationens fakturaadresser.",
    "rental.hourlyRate": "Timpris (kr/h)",
    "rental.responsible": "Ansvarig användare",
    "rental.requiredHint": "Välj projekt och ansvarig användare",
    "rental.willGenerate": "→ Uthyrningsrapport skapas vid återlämning",
    "rental.accountingEmails": "Fakturamottagare (e-post)",
    "rental.accountingEmailsHelp": "Mottagare av automatiska uthyrningsrapporter. En per rad.",
    "rental.saved": "Inställningar sparade",
    "trl.title": "Släpvagnar",
    "trl.label": "[ Släpvagnsflotta ]",
    "trl.new": "Ny släpvagn",
    "trl.empty": "Inga släpvagnar ännu",
    "trl.namn": "Visningsnamn",
    "trl.kapacitet": "Lastkapacitet (kg)",
    "trl.storlek": "Storlek",
    "trl.book": "Boka",
    "trl.created": "Släpvagn skapad",
    "trl.updated": "Släpvagn uppdaterad",
    "trl.deleted": "Släpvagn borttagen",
    "trl.duplicate": "En släpvagn med detta regnr finns redan",
    "rrep.title": "Uthyrningsrapporter",
    "rrep.subtitle": "Automatiska sammanfattningar från återlämnade kund-uthyrningar — exporterbara för fakturering",
    "rrep.totalHours": "Total tid",
    "rrep.totalCost": "Total kostnad",
    "rrep.count": "Antal",
    "rrep.resource": "Resurs",
    "rrep.project": "Projekt",
    "rrep.responsible": "Ansvarig",
    "rrep.duration": "Tid",
    "rrep.cost": "Kostnad",
    "rrep.empty": "Inga uthyrningsrapporter ännu",
    "rrep.emailSent": "E-post skickad",
    "rrep.emailPending": "Ej skickad",
    "rrep.resend": "Skicka igen",
    "rrep.exportCsv": "Exportera CSV",
    "rrep.filter.all": "Alla resurstyper",
    "rrep.filter.machine": "Maskiner",
    "rrep.filter.trailer": "Släpvagnar",
    "rrep.filter.days30": "30 dagar",
    "rrep.filter.days90": "90 dagar",
    "rrep.filter.days365": "1 år",
    "rrep.filter.all_time": "Alla",
    "cal.legend.free": "Ledig",
    "cal.legend.partial": "Delvis bokad",
    "cal.legend.full": "Helt bokad",

    // Locked-module gating for unauthenticated visitors
    "locked.hover": "Denna modul ingår i ReSource Hybrid/Organisation. Kontakta oss för att aktivera.",
    "locked.modal.title": "Hybrid/Organisation krävs",
    "locked.modal.text": "Denna modul ingår i ReSource Hybrid/Sluten. Kontakta oss för att aktivera.",
    "locked.modal.hint": "Har du redan ett konto? Logga in för att fortsätta.",
    "locked.modal.button": "Kontakta oss",
    "locked.modal.later": "Stäng",

    // ========== Landing page v2 (conversion-optimized) ==========
    "lp.hero.pretitle": "FÖR BYGGBOLAG · KOMMUNER · REGIONER",
    "lp.hero.h1a": "Sluta köpa nytt.",
    "lp.hero.h1b": "Börja dela.",
    "lp.hero.sub": "ReSource Build samlar material, maskiner, fordon och inventarier i en plattform. Mindre svinn, lägre kostnad, automatisk CO₂-rapport — synligt från dag ett.",
    "lp.hero.audience": "Byggentreprenörer · Maskinuthyrare · UE · Kommuner & regioner",
    "lp.hero.note": "Igång på en eftermiddag. Inget Excel. Inga konsulter.",
    "lp.hero.ctaDemo": "Boka demo",
    "lp.hero.ctaTry": "Bläddra material",
    "lp.hero.ctaSample": "Utforska plattformen",
    "lp.hero.trust": "Byggt för svenska byggbolag, kommuner och regioner",
    "lp.hero.uiLabel": "[ UI · Översikt ]",
    "lp.hero.uiCaption": "Material · Maskiner · Fordon · Inventarie — en vy",

    "lp.value.title": "Konkreta resultat — från första bokningen.",
    "lp.value.v1": "Sänk inköpskostnaden 15–30 % via återbruk och delning mellan projekt",
    "lp.value.v2": "Höj återbruksgraden — mät ton material återanvänt per projekt och period",
    "lp.value.v3": "Full synlighet över material, maskiner och fordon — en sida, inget Excel",
    "lp.value.v4": "Automatisk CO₂e-rapport för CSRD, taxonomi och kommunala upphandlingar",
    "lp.value.v5": "Uthyrning till fakturaunderlag automatiskt — projekt, tid och pris vid återlämning",

    "lp.fleet.label": "[ 03 · Fordon & flotta ]",
    "lp.fleet.title": "Utsläpp per fordon. Per projekt. Per period.",
    "lp.fleet.sub": "Hel kontroll på flottans CO₂-avtryck — automatiskt, individuellt och rapporterbart för hållbarhetsredovisning eller upphandling.",
    "lp.fleet.b1": "Diesel, bensin, HVO, el, hybrid — svenska faktorer",
    "lp.fleet.b2": "Aggregera per projekt för rena kundrapporter",
    "lp.fleet.b3": "Månads-, kvartals- och årsrapport, exporterbar",
    "lp.fleet.b4": "Auto-påminnelser för besiktning & service",
    "lp.fleet.cta": "Utforska fordon",
    "lp.fleet.rentalCta": "Uthyrningsrapporter",
    "lp.fleet.uiLabel": "[ UI · Utsläppsrapport ]",
    "lp.fleet.uiCaption": "Volvo FH · Scania R450 · Tesla M3 — kg CO₂e per fordon",

    "lp.co2e.label": "[ 04 · CO₂e Dashboard ]",
    "lp.co2e.title": "Klimatpåverkan — synlig från första bokningen.",
    "lp.co2e.sub": "Generiska klimatfaktorer är inbakade. Inga kalkylblad. Inga konsulter.",
    "lp.co2e.howT": "Så räknar vi",
    "lp.co2e.how1": "Drivmedel + svensk elmix → emissionsfaktor per km / kWh",
    "lp.co2e.how2": "Materialvikt × kategorifaktor för undviken produktion",
    "lp.co2e.how3": "Uthyrning vs nyköp → besparad produktionsutsläpp per bokning",
    "lp.co2e.b1": "Totalt CO₂e — hela organisationen",
    "lp.co2e.b2": "Per projekt, månad, kategori",
    "lp.co2e.b3": "Topp 10 maskiner och material",
    "lp.co2e.b4": "Rent vs köp — sida vid sida",
    "lp.co2e.cta": "Öppna dashboard",
    "lp.co2e.uiLabel": "[ UI · CO₂e-besparing ]",
    "lp.co2e.uiCaption": "2 140 kg total · 48 bokningar · 12 projekt — exempel",

    "lp.feat.label": "[ Funktioner ]",
    "lp.feat.title": "En plattform. Sex flöden.",
    "lp.feat.uiLabel": "UI-förhandsvisning",
    "lp.feat.materialT": "Materialmarknad",
    "lp.feat.material1": "Foto, kvalitet, kvantitet, CO₂",
    "lp.feat.material2": "Boka avhämtning eller leverans",
    "lp.feat.material3": "Intern, hybrid eller publik",
    "lp.feat.materialCta": "Se marknaden",
    "lp.feat.machT": "Maskiner & verktyg",
    "lp.feat.mach1": "Kalenderbokning utan krockar",
    "lp.feat.mach2": "QR-bokning på sekunder",
    "lp.feat.mach3": "Drifttid & service automatiskt",
    "lp.feat.machCta": "Visa maskiner",
    "lp.feat.vehT": "Fordon & utsläpp",
    "lp.feat.veh1": "CO₂ per fordon, projekt, period",
    "lp.feat.veh2": "Påminnelser för service & besiktning",
    "lp.feat.veh3": "Släp + uthyrningsrapport automatiskt",
    "lp.feat.vehCta": "Utforska fordon",
    "lp.feat.invT": "Inventarie & bodar",
    "lp.feat.inv1": "Bodar, ställningar, säkerhet",
    "lp.feat.inv2": "Status & historik per enhet",
    "lp.feat.inv3": "QR-tag på varje enhet",
    "lp.feat.invCta": "Visa inventarie",
    "lp.feat.collabT": "Samarbete & nätverk",
    "lp.feat.collab1": "Bjud in partners & UE",
    "lp.feat.collab2": "Boka över organisationsgränser",
    "lp.feat.collab3": "Synlighet per resurs",
    "lp.feat.collabCta": "Bygg ditt nätverk",
    "lp.feat.co2T": "CO₂-dashboard",
    "lp.feat.co21": "Real-time besparingar — alla flöden",
    "lp.feat.co22": "Per projekt · månad · kategori",
    "lp.feat.co23": "Exportera för CSRD",
    "lp.feat.co2Cta": "Öppna dashboard",

    "lp.uspLabel": "[ Varför nu ]",
    "lp.uspTitle": "Bygget förändras — snabbare än någonsin.",
    "lp.usp1T": "Byggkostnader skenar",
    "lp.usp1B": "Materialpriser upp 20–40 % sedan 2022. Återbruk och delning sänker inköpsnotan direkt — utan kvalitetskompromiss.",
    "lp.usp2T": "Avfallsregler skärps",
    "lp.usp2B": "EU:s mål: bygg- och rivningsavfall ska minska 70 % till 2030. Spårbar återanvändning blir ett krav, inte en bonus.",
    "lp.usp3T": "CSRD & taxonomi 2026",
    "lp.usp3B": "Stora bolag måste rapportera scope 3-utsläpp. UE och leverantörer dras in — utan data är du borta från upphandlingar.",
    "lp.usp4T": "Klimatkrav i upphandling",
    "lp.usp4B": "Kommuner och regioner kräver CO₂e-data i offerter. ReSource Build levererar det — automatiskt, från första bokningen.",

    "lp.proofLabel": "[ Social proof ]",
    "lp.proofTitle": "Customer stories coming soon",
    "lp.proofSub": "Vi bygger fallstudier tillsammans med våra första kunder. Bli en av dem — och få din logga och ditt resultat här.",
    "lp.proofLogoPlaceholder": "Din logga här",
    "lp.proofCaseT": "Fallstudie kommer snart",
    "lp.proofCaseB": "Mätbara resultat från riktiga byggprojekt — ton material återanvänt, kg CO₂e besparat, kostnader minskade.",
    "lp.proofCaseCta": "Bli en pilotpartner",

    "lp.priceLabel": "[ Pricing ]",
    "lp.priceTitle": "Välj nivå som matchar din verksamhet",
    "lp.priceSub": "Från 0 kr/mån. Skalbar med din organisation. Byt när du vill.",
    "lp.priceRec": "Rekommenderas",
    "lp.priceFromLabel": "Från",
    "lp.priceOpenT": "Open",
    "lp.priceOpenP": "0 kr",
    "lp.priceOpenPHint": "/mån — för alltid",
    "lp.priceOpenDesc": "Publik marknadsplats för materialåterbruk",
    "lp.priceOpen1": "Obegränsade listningar",
    "lp.priceOpen2": "Publik synlighet",
    "lp.priceOpen3": "Bas-CO₂ per listning",
    "lp.priceOpen4": "E-post-support",
    "lp.priceOpenCta": "Kom igång gratis",
    "lp.priceHybridT": "Hybrid",
    "lp.priceHybridP": "1 990 kr",
    "lp.priceHybridPHint": "/mån — från",
    "lp.priceHybridDesc": "För org. som vill dela internt + handla externt",
    "lp.priceHybrid1": "Allt i Open",
    "lp.priceHybrid2": "Maskiner, fordon & inventarie",
    "lp.priceHybrid3": "Projekt, roller & samarbetsnätverk",
    "lp.priceHybrid4": "Full CO₂-dashboard + export",
    "lp.priceHybrid5": "Prioriterad support",
    "lp.priceHybridCta": "Boka demo",
    "lp.priceClosedT": "Closed Enterprise",
    "lp.priceClosedP": "Custom",
    "lp.priceClosedPHint": "pris på begäran",
    "lp.priceClosedDesc": "Internt-bara, full revision, SSO",
    "lp.priceClosed1": "Allt i Hybrid",
    "lp.priceClosed2": "Internt-bara marknadsplats",
    "lp.priceClosed3": "Audit log + SSO",
    "lp.priceClosed4": "Dedikerad success manager",
    "lp.priceClosed5": "SLA + onboarding",
    "lp.priceClosedCta": "Kontakta säljare",

    "lp.cmp.title": "Vad ingår var",
    "lp.cmp.colFeat": "Funktion",
    "lp.cmp.r1": "Materiallistingar (publik)",
    "lp.cmp.r2": "Maskinbokning & kalender",
    "lp.cmp.r3": "Fordon & flotta + CO₂",
    "lp.cmp.r4": "Inventarie & QR-koder",
    "lp.cmp.r5": "Samarbetsnätverk",
    "lp.cmp.r6": "Uthyrningsrapport + fakturamail",
    "lp.cmp.r7": "Audit log & SSO",
    "lp.cmp.r8": "Dedikerad success manager + SLA",

    "lp.endLabel": "[ Sluta vänta ]",
    "lp.endTitle": "Lägg in första maskinen idag.",
    "lp.endSub": "30 minuter till första bokningen. Spara från första uthyrningen. Mät från första kilometern.",
    "lp.endTrust": "Inget kreditkort · Ingen bindningstid · Svensk support",
  },

  en: {
    "nav.marketplace": "Marketplace",
    "nav.addListing": "Add Listing",
    "nav.dashboard": "Dashboard",
    "nav.signIn": "Sign in",
    "nav.signOut": "Log out",
    "nav.footer": "ReSource Build / Circular construction",
    "nav.noRole": "no role",
    "role.seller": "seller",
    "role.buyer": "buyer",
    "role.admin": "admin",
    "role.switcher": "Switch role:",

    "landing.hero.label": "[ 001 / Circular Construction Marketplace ]",
    "landing.hero.title1": "The marketplace",
    "landing.hero.title2": "for materials with",
    "landing.hero.title3": "a second life.",
    "landing.hero.subtitle": "Post your surplus bricks, timber, tiles and steel — or book reclaimed materials from builders near you. Pickup or delivery.",
    "landing.hero.browse": "Browse materials",
    "landing.hero.pickup": "Available for pickup",
    "landing.stats.tons": "Tons diverted",
    "landing.stats.sellers": "Active sellers",
    "landing.stats.categories": "Categories",
    "landing.intake.label": "Latest intake",
    "landing.intake.text": "Stockholm warehouse · 2,400 reclaimed bricks",
    "landing.cats.label": "[ Categories ]",
    "landing.cats.title": "Shop by material",
    "landing.cats.viewAll": "View all →",
    "landing.cats.category": "Category",
    "landing.how.label": "[ How it works ]",
    "landing.how.title": "Built for building.",
    "landing.how.s1.title": "01 / List surplus",
    "landing.how.s1.body": "Contractors and demolition teams post leftover stock with photos, quantity and quality grade.",
    "landing.how.s2.title": "02 / Book & reserve",
    "landing.how.s2.body": "Buyers reserve exactly what they need — by pallet, square meter, or piece.",
    "landing.how.s3.title": "03 / Pickup or delivery",
    "landing.how.s3.body": "Choose handover. Sellers confirm, buyers collect or get it delivered.",
    "landing.cta.label": "[ Start selling ]",
    "landing.cta.title": "Got leftover materials? Turn waste into value.",
    "landing.cta.browse": "Browse first",
    "landing.cta.sell": "Start selling",

    "market.label": "[ Inventory ]",
    "market.title": "Marketplace",
    "market.scopePublic": "Public",
    "market.scopePublicHint": "All published materials visible to everyone",
    "market.scopeShared": "Shared",
    "market.scopeSharedHint": "Materials your collaboration partners share with you",
    "market.scopeOwn": "Internal",
    "market.scopeOwnHint": "Only materials your own organisation has added",
    "market.projectFilter": "Project:",
    "market.projectAll": "All projects",
    "market.bulkSelected": "{n} selected",
    "market.bulkMove": "Move to project",

    // Move material
    "move.label": "[ Move material ]",
    "move.title": "Move to another project",
    "move.bulkLabel": "[ Bulk move ]",
    "move.bulkTitle": "Move {n} materials",
    "move.targetProject": "Target project",
    "move.targetPlaceholder": "Pick a project…",
    "move.targetDetach": "— No project (detach) —",
    "move.currentMark": "current",
    "move.warehouseHint": "Tip: this looks like a warehouse project. Good for demolished materials going to central storage.",
    "move.note": "Note (optional)",
    "move.notePh": "E.g. \"Demolition complete — moved to central storage\"",
    "move.confirm": "Move",
    "move.moving": "Moving…",
    "move.success": "Material moved",
    "move.bulkSuccess": "{moved} of {total} moved",
    "move.failed": "Could not move",
    "move.pickTarget": "Pick a target project first",
    "move.sameTarget": "Already in that project",
    "move.openBtn": "Move to project",
    "move.historyShow": "Show move history",
    "move.historyHide": "Hide move history",
    "move.historyTitle": "Move history",
    "move.historyEmpty": "No moves recorded yet",
    "move.noProject": "—",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.close": "Close",
    "market.items": "items",
    "market.grid": "Grid",
    "market.map": "Map",
    "market.filters": "Filters",
    "market.search": "Search",
    "market.searchPh": "Bricks, beams...",
    "market.category": "Category",
    "market.allCategories": "All categories",
    "market.quality": "Quality",
    "market.any": "Any",
    "market.locationText": "Location (text)",
    "market.locationPh": "City or region",
    "market.distance": "Distance",
    "market.useMyLocation": "Use my location",
    "market.within": "Within",
    "market.kmFromYou": "km of you",
    "market.clearLocation": "Clear location",
    "market.handover": "Handover",
    "market.pickupAvailable": "Pickup available",
    "market.deliveryAvailable": "Delivery available",
    "market.reset": "Reset filters",
    "market.loading": "Loading inventory...",
    "market.emptyLabel": "[ Empty shelf ]",
    "market.emptyTitle": "No materials match",
    "market.emptyBody": "Try loosening your filters — or be the first to post this kind of material.",
    "market.geoUnsupported": "Geolocation not supported",
    "market.centered": "Centered on your location",
    "market.geoFailed": "Could not get your location",

    "card.noImage": "No image",
    "card.free": "Free",
    "card.view": "View →",
    "card.fullyBooked": "Fully booked",
    "card.kmAway": "km away",
    "detail.back": "← Back to marketplace",
    "detail.loading": "Loading...",
    "detail.notFound": "Listing not found",
    "detail.pickup": "Pickup",
    "detail.delivery": "Delivery",
    "detail.available": "available",
    "detail.remaining": "remaining",
    "detail.price": "Price",
    "detail.freeHandover": "Free handover",
    "detail.description": "Description",
    "detail.seller": "Seller",
    "detail.bookBtn": "Book this material",
    "detail.loginFirst": "Sign in first to book this material",
    "detail.switchBuyer": "Switch to buyer role in dashboard to book",
    "detail.cantBookOwn": "You cannot book your own listing",

    "book.label": "[ Book material ]",
    "book.quantity": "Quantity",
    "book.available": "available",
    "book.remaining": "remaining",
    "book.method": "Handover method",
    "book.address": "Delivery address",
    "book.addressPh": "Street, city, postal code",
    "book.note": "Note to seller",
    "book.notePh": "When can you pick up? Any specifics?",
    "book.submit": "Send booking request",
    "book.sending": "Sending...",
    "book.quantityErr": "Quantity must be between 1 and",
    "book.addressErr": "Please provide a delivery address",
    "book.sent": "Booking request sent!",
    "book.failed": "Booking failed",

    "add.label": "[ New listing ]",
    "add.title": "Post material",
    "add.loginRequired": "Sign in required.",
    "add.roleRequiredLabel": "[ Role required ]",
    "add.roleRequired": "You need seller role to list materials",
    "add.goDashboard": "Go to dashboard",
    "add.photos": "Photos",
    "add.dropPhotos": "Drop photos or click to browse",
    "add.uploading": "Uploading...",
    "add.photoHint": "JPG / PNG · up to 10 MB each",
    "add.titleField": "Title",
    "add.titlePh": "e.g. 500 reclaimed red bricks",
    "add.descField": "Description",
    "add.descPh": "Dimensions, origin, condition notes...",
    "add.categoryField": "Category",
    "add.qualityField": "Quality",
    "add.quantityField": "Quantity available",
    "add.unitField": "Unit",
    "add.weightLabel": "Weight per unit — required for accurate CO₂e calculation",
    "add.weightHelp": "This category is measured per kilogram. Because the unit is \"{unit}\", we need the weight per unit to compute the climate benefit correctly. Leave empty if unknown — CO₂e will show as 0 kg.",
    "add.weightPreview": "≈ {qty} {unit} × {weight} kg = {co2e} kg CO₂e (preview)",
    "add.locationField": "Location",
    "add.locationPh": "City, region",
    "add.mapLabel": "Pin on map (optional — enables radius search)",
    "add.priceField": "Price (€) · 0 = free",
    "add.handover": "Handover options",
    "add.pickup": "Pickup",
    "add.delivery": "Delivery",
    "add.cancel": "Cancel",
    "add.publish": "Publish listing",
    "add.publishing": "Publishing...",
    "add.editLabel": "[ Edit listing ]",
    "add.editTitle": "Edit listing",
    "add.saveChanges": "Save changes",
    "add.saving": "Saving...",
    "add.updateOk": "Listing updated",
    "add.updateFail": "Couldn't update the listing",
    "detail.edit": "Edit",
    "add.uploadOk": "image(s) uploaded",
    "add.uploadFail": "Upload failed",
    "add.fillErr": "Please fill title, description, and location",
    "add.publishOk": "Listing published!",
    "add.publishFail": "Failed to publish",

    "dash.welcome": "[ Welcome,",
    "dash.pickRole": "Pick your role",
    "dash.pickRoleBody": "You can change this later. Sellers post materials. Buyers browse and book them.",
    "dash.iamSeller": "I'm a Seller",
    "dash.iamSellerBody": "Post surplus bricks, timber, tiles — turn leftover stock into income.",
    "dash.iamBuyer": "I'm a Buyer",
    "dash.iamBuyerBody": "Browse reclaimed materials and book exactly what you need for your project.",
    "dash.roleSet": "Role set to",
    "dash.roleFail": "Failed to set role",
    "dash.switched": "Switched to",
    "dash.label": "[ Dashboard /",
    "dash.hello": "Hello,",
    "dash.switchTo": "Switch to",
    "dash.newListing": "New listing",
    "dash.myListings": "My listings",
    "dash.incoming": "Incoming bookings",
    "dash.myBookings": "My bookings",
    "dash.emptyInventory": "[ Empty inventory ]",
    "dash.noListings": "No listings yet",
    "dash.postFirst": "Post your first listing",
    "dash.noIncoming": "No incoming bookings",
    "dash.noBookings": "No bookings yet",
    "dash.browse": "Browse marketplace",
    "dash.from": "from",
    "dash.approve": "Approve",
    "dash.reject": "Reject",
    "dash.complete": "Mark completed",
    "dash.cancel": "Cancel",
    "dash.confirmDelete": "Delete this listing?",
    "dash.deleted": "Deleted",
    "dash.failed": "Failed",
    "dash.markedAs": "Marked as",

    "status.pending": "pending",
    "status.approved": "approved",
    "status.rejected": "rejected",
    "status.completed": "completed",
    "status.cancelled": "cancelled",
    "status.expired": "expired",
    "dash.expiresInDays": "Auto-cancels in {n} d if not approved",
    "dash.expiresInHours": "Auto-cancels in {n} h if not approved",
    "dash.expiresHint": "Pending bookings auto-expire after 7 days",

    "map.pin": "Pin:",
    "map.geocoding": "geocoding...",
    "map.clickToPin": "Click map to drop pin",
    "map.useLocation": "Use my location",
    "map.viewListing": "View listing →",
    "map.kmAway": "km away",

    "notif.title": "Notifications",
    "notif.empty": "No notifications yet",
    "notif.markAllRead": "Mark all as read",
    "notif.justNow": "just now",
    "notif.minAgo": "min ago",
    "notif.hAgo": "h ago",
    "notif.dAgo": "d ago",
    "notif.booking_created": "New booking request from {other} for {listing}",
    "notif.booking_approved": "{other} approved your booking for {listing}",
    "notif.booking_rejected": "{other} rejected your booking for {listing}",
    "notif.booking_completed": "Booking for {listing} was marked completed",
    "notif.booking_cancelled": "{other} cancelled the booking for {listing}",
    "notif.booking_expired": "Your booking for {listing} has expired (not approved within 7 days)",
    "notif.rating_received": "{other} left a review for {listing}",
    "notif.collab_invite_received": "{other} invited your organisation to collaborate",
    "notif.collab_invite_accepted": "{other} accepted your collaboration invite",
    "notif.collab_invite_declined": "{other} declined your collaboration invite",
    "notif.user_invite_received": "{other} invited you to join the organisation",
    "notif.user_invite_accepted": "{other} accepted your invite",
    "notif.user_invite_declined": "{other} declined your invite",

    // User-to-Org invitations (domain-matched colleagues)
    "uinv.title": "Invite users to the organisation",
    "uinv.help": "Users who registered with the same email domain as your organisation appear here. You can also enter an email manually.",
    "uinv.noMatches": "No matching users right now.",
    "uinv.inviteBtn": "Invite",
    "uinv.manualEmail": "Invite by email",
    "uinv.send": "Send",
    "uinv.cancel": "Cancel",
    "uinv.sent": "Invitation sent",
    "uinv.cancelled": "Invitation cancelled",
    "uinv.pendingOutgoing": "Outgoing invitations",
    "uinv.invitesTitle": "Organisation invitations",
    "uinv.subscription": "Model",
    "uinv.acceptBtn": "Accept",
    "uinv.declineBtn": "Decline",
    "uinv.accepted": "You have joined the organisation",
    "uinv.declined": "Invitation declined",
    "uinv.modalTitle": "How would you like to join?",
    "uinv.modalHelp": "Choose to bring your listings, machines and inventory along, or start fresh.",
    "uinv.modeMerge": "Join + bring data",
    "uinv.modeMergeHelp": "All your listings, machines and inventory move to the new organisation. Your personal account is removed if empty.",
    "uinv.modeDetach": "Join + start fresh",
    "uinv.modeDetachHelp": "Start fresh in the organisation. Your personal account keeps the data but needs a new email attached.",
    "uinv.newEmailPlaceholder": "New email for personal account",
    "uinv.confirmAccept": "Confirm",
    "notif.toastNew": "New notification",

    "saved.tab": "Saved",
    "saved.empty": "No saved listings yet",
    "saved.emptyBody": "Tap the heart on a listing to save it here.",
    "saved.addToast": "Saved",
    "saved.removeToast": "Removed",
    "saved.requireLogin": "Sign in to save listings",

    "rating.summary": "{up} thumbs up of {total}",
    "rating.none": "No reviews yet",
    "rating.thumbUp": "Thumbs up",
    "rating.thumbDown": "Thumbs down",
    "rating.rate": "Rate the seller",
    "rating.rated": "Thanks for your review!",
    "rating.alreadyRated": "Already rated",

    "admin.title": "Admin panel",
    "admin.notAllowed": "Administrator access required",
    "admin.tab.stats": "Stats",
    "admin.tab.listings": "Listings",
    "admin.tab.bookings": "Bookings",
    "admin.tab.users": "Users",
    "admin.tab.reports": "Reports",
    "admin.tab.ratings": "Ratings",
    "admin.tab.orgs": "Organizations",
    "admin.tab.audit": "Audit log",
    "admin.tab.i18n": "Texts",
    "admin.i18n.searchPh": "Search keys or text…",
    "admin.i18n.overrideCount": "{n} overrides",
    "admin.i18n.help": "Edit UI texts live. Empty values render as empty strings. Press Reset to revert to the shipped default.",
    "admin.i18n.base": "Default",
    "admin.i18n.overridden": "Overridden",
    "admin.i18n.save": "Save",
    "admin.i18n.resetBtn": "Reset",
    "admin.i18n.saved": "Saved",
    "admin.i18n.reset": "Reset",
    "admin.i18n.truncated": "Showing 500 of {n}. Refine the search to see more.",
    "admin.audit.actorPh": "Filter by email…",
    "admin.audit.actionPh": "Filter by action…",
    "admin.audit.refresh": "Refresh",
    "admin.audit.exportCsv": "Export CSV",
    "admin.audit.exported": "CSV exported",
    "admin.audit.empty": "No audit events yet",
    "admin.audit.by": "by",
    "admin.audit.showDetails": "Show details",
    "admin.audit.hideDetails": "Hide details",
    "admin.orgs.title": "Organizations",
    "admin.orgs.newBtn": "New organization",
    "admin.orgs.name": "Name",
    "admin.orgs.type": "Type",
    "admin.orgs.owner": "Owner (email)",
    "admin.orgs.created": "Created",
    "admin.orgs.actions": "Actions",
    "admin.orgs.edit": "Edit",
    "admin.orgs.delete": "Delete",
    "admin.orgs.save": "Save",
    "admin.orgs.cancel": "Cancel",
    "admin.orgs.confirmDelete": "Delete organization?",
    "admin.orgs.createOk": "Organization created",
    "admin.orgs.updateOk": "Organization updated",
    "admin.orgs.deleteOk": "Organization deleted",
    "admin.orgs.empty": "No organizations yet",
    "admin.stats.users": "Users",
    "admin.stats.listings": "Listings total",
    "admin.stats.hidden": "Hidden listings",
    "admin.stats.bookings": "Bookings",
    "admin.stats.pending": "Pending",
    "admin.stats.completed": "Completed",
    "admin.stats.rejected": "Rejected",
    "admin.stats.reports": "Open reports",
    "admin.stats.ratings": "Ratings total",
    "admin.stats.ratingsUp": "Thumbs up",
    "admin.listings.search": "Search title, location or seller",
    "admin.hide": "Hide",
    "admin.unhide": "Show",
    "admin.delete": "Delete",
    "admin.forceStatus": "Force status",
    "admin.suspend": "Suspend",
    "admin.unsuspend": "Reinstate",
    "admin.setRole": "Set role",
    "admin.report.reason": "Reason",
    "admin.report.resolve": "Resolve report",
    "admin.confirmDelete": "Are you sure?",
    "admin.actionOk": "Done",
    "admin.hidden": "hidden",
    "admin.suspended": "suspended",
    "admin.reportBtn": "Report",
    "admin.reportPrompt": "Why are you reporting this listing?",
    "admin.reportSent": "Report sent. Thank you!",
    "admin.bulk.selected": "selected",
    "admin.bulk.selectAll": "Select all",
    "admin.bulk.clear": "Clear selection",
    "admin.bulk.hide": "Hide selected",
    "admin.bulk.unhide": "Show selected",
    "admin.bulk.delete": "Delete selected",
    "admin.bulk.done": "{n} listings affected",
    "admin.bulk.usersDone": "{n} users affected",
    "admin.bulk.suspend": "Suspend selected",
    "admin.bulk.unsuspend": "Reinstate selected",
    "admin.bulk.delete": "Delete selected",
    "admin.bulk.confirmDelete": "Are you sure you want to delete {n} users? This cannot be undone.",
    "admin.user.org": "Organisation",
    "admin.createUser.btn": "Create user",
    "admin.createUser.title": "Create new user",
    "admin.createUser.email": "Email",
    "admin.createUser.name": "Name",
    "admin.createUser.password": "Password",
    "admin.createUser.passwordPlaceholder": "Leave empty to generate",
    "admin.createUser.role": "Role",
    "admin.createUser.rolePending": "— pick later —",
    "admin.createUser.org": "Organisation",
    "admin.createUser.orgPersonal": "Personal org (will be created)",
    "admin.createUser.submit": "Create account",
    "admin.createUser.created": "User created",
    "admin.createUser.tempPwTitle": "Temporary password (shown only now)",
    "admin.createUser.tempPwHelp": "Copy the password and share it with the user via a secure channel. They can change it on first login.",
    "admin.createUser.done": "Done",

    "auth.signingIn": "[ Signing you in... ]",

    "cat.Wood": "Wood / Timber",
    "cat.Bricks": "Bricks",
    "cat.Concrete": "Concrete",
    "cat.Metal": "Metal",
    "cat.Glass": "Glass",
    "cat.Tiles": "Tiles",
    "cat.Insulation": "Insulation",
    "cat.DoorsWindows": "Doors & Windows",
    "cat.Roofing": "Roofing",
    "cat.Other": "Other",

    "unit.pcs": "pcs",
    "unit.m": "m",
    "unit.m2": "m²",
    "unit.m3": "m³",
    "unit.kg": "kg",
    "unit.ton": "ton",
    "unit.pallet": "pallet",

    "price.currency": "€",

    // Organisation / Operating model
    "org.tab": "Organization",
    "org.title": "Organization & Operating Model",
    "org.label": "[ Operations ]",
    "org.name": "Organization name",
    "org.subscription": "Subscription",
    "org.sub.intern": "Closed (internal tracking only)",
    "org.sub.hybrid": "Hybrid (internal + external transfer)",
    "org.sub.oppen": "Open (public marketplace)",
    "org.subShort.intern": "Closed",
    "org.subShort.hybrid": "Hybrid",
    "org.subShort.oppen": "Open",
    "org.adminOnlyHint": "Only admins can change organization type or subscription.",
    "org.save": "Save",
    "org.saved": "Updated",
    "org.co2eTotal": "Total CO2e saved",
    "org.co2ePerCat": "Per category",
    "org.listingsTotal": "Listings total",
    "org.internal": "Internal",
    "org.external": "External",
    "org.published": "Published",
    "org.kg": "kg CO2e",
    "org.kalla": "Source: generic climate data",
    "org.transfers": "External transfers",
    "org.noTransfers": "No external transfers yet",
    "org.newTransfer": "Log external transfer",
    "org.transfer.type": "Transfer type",
    "org.transfer.forsaljning": "Sale",
    "org.transfer.overlatelse": "Handover",
    "org.transfer.donation": "Donation",
    "org.transfer.receiver": "Receiver",
    "org.transfer.date": "Date",
    "org.transfer.create": "Record",
    "org.transfer.created": "External transfer recorded",
    "org.transfer.failed": "Could not record transfer",
    "org.transfer.selectListing": "Select listing",
    "org.transfer.forbiddenIntern": "Internal subscription does not allow external transfers",

    // Listing extras
    "add.ursprung": "Origin / project (optional)",
    "add.ursprungPh": "e.g. demolition Hagastaden stage 3",
    "add.destination": "Destination",
    "add.destIntern": "Internal (reused within organization)",
    "add.destExtern": "External (shared outside organization)",
    "add.konto": "Cost center / account",
    "add.kontoPh": "e.g. 4010 – Build project South",
    "add.publicerad": "Publish externally on marketplace",
    "add.publiceradHintIntern": "Internal subscription: listing will not be published externally",
    "add.traceTitle": "Traceability & operations",

    // Detail
    "detail.co2eSaved": "CO2e saved",
    "detail.co2eKalla": "generic climate data",
    "detail.co2eMissingWeight": "Weight per unit missing — CO₂e not calculated",
    "detail.co2eMissingWeightHelp": "This listing is in a category measured per kilogram, but the unit is not kg/ton. To show the climate benefit correctly, click Edit and fill in the weight per unit.",

    // Role switcher
    "role.view.admin": "View as admin",
    "role.view.seller": "View as seller",
    "role.view.buyer": "View as buyer",

    // Brand & top nav
    "brand.name": "ReSource Build",
    "nav.material": "Material",
    "nav.machines": "Machines & Tools",
    "nav.inventory": "Inventory",
    "nav.projects": "Projects",
    "nav.backToList": "← Back to list",

    // Machines
    "mach.title": "Machines & Tools",
    "mach.label": "[ Equipment fleet ]",
    "mach.new": "New machine",
    "mach.namn": "Name",
    "mach.typ": "Type",
    "mach.plats": "Location",
    "mach.ansvarig": "Responsible",
    "mach.status": "Status",
    "mach.driftstimmar": "Operating hours",
    "mach.serviceintervall": "Service interval (h)",
    "mach.co2eKop": "Generic CO2e if purchased new (kg)",
    "mach.co2ePerKm": "CO2e transport per km (kg)",
    "mach.bookBtn": "Book machine",
    "mach.calendar": "Calendar",
    "mach.empty": "No machines yet",
    "mach.statusTillganglig": "Available",
    "mach.statusBokad": "Booked",
    "mach.statusUtlamnad": "Out",
    "mach.statusService": "Service",
    "mach.statusTrasig": "Broken",
    "mach.created": "Machine created",
    "mach.updated": "Machine updated",
    "mach.newTitle": "New machine / tool",
    "mach.editTitle": "Edit machine / tool",
    "mach.updated": "Machine updated",
    "mach.deleted": "Machine deleted",
    "mach.confirmDelete": "Delete this machine?",

    // Inventory
    "inv.title": "Inventory",
    "inv.label": "[ Inventory store ]",
    "inv.new": "New inventory item",
    "inv.namn": "Name",
    "inv.typ": "Type (e.g. helmet, harness, instrument)",
    "inv.plats": "Location",
    "inv.status": "Status",
    "inv.statusLedig": "Free",
    "inv.statusUte": "Out",
    "inv.statusTrasig": "Broken",
    "inv.empty": "No inventory yet",
    "inv.history": "History",
    "inv.created": "Inventory item created",
    "inv.newTitle": "New inventory item",
    "inv.editTitle": "Edit inventory item",
    "inv.updated": "Inventory item updated",
    "inv.deleted": "Inventory item deleted",

    // Projects
    "prj.title": "Projects",
    "prj.label": "[ Project register ]",
    "prj.new": "New project",
    "prj.namn": "Project name",
    "prj.plats": "Location",
    "prj.ansvarig": "Responsible",
    "prj.beskrivning": "Description",
    "prj.empty": "No projects yet",
    "prj.attach": "Add to project",
    "prj.detach": "Remove from project",
    "prj.attached": "Added to project",
    "prj.attachedTo": "Linked to {name}",
    "prj.detached": "Link removed",
    "prj.linkedTo": "Linked to",
    "prj.linkedBadge": "LINKED",
    "prj.changeLink": "Change project",
    "prj.removeLink": "Remove link",
    "prj.pickProject": "Choose a project…",
    "prj.noneYet": "No projects yet — create one under Projects first",
    "prj.unknownProject": "(unknown project)",
    "prj.linked": "Linked objects",
    "prj.linkedNone": "No linked objects yet",
    "prj.created": "Project created",
    "prj.updated": "Project updated",
    "prj.deleted": "Project deleted",
    "prj.selectProject": "Select project",

    // Machine booking
    "mbk.title": "Machine bookings",
    "mbk.start": "Start",
    "mbk.slut": "End",
    "mbk.transportKm": "Transport distance (km round trip)",
    "mbk.note": "Note",
    "mbk.book": "Book",
    "mbk.created": "Booking created",
    "mbk.collision": "The machine is already booked in this timeframe",
    "mbk.cal.title": "Booked in this calendar",
    "mbk.cal.allFree": "Machine is free — pick any time",
    "mbk.cal.freeFrom": "Available from",
    "mbk.cal.jumpBtn": "Use this time",
    "mbk.cal.conflict": "Conflicts with existing booking",
    "mbk.cal.booked": "Booked",
    "mbk.cal.out": "Out",
    "mbk.approve": "Approve",
    "mbk.pickup": "Mark as picked up",
    "mbk.return": "Mark as returned",
    "mbk.cancel": "Cancel booking",
    "mbk.statusBokad": "Booked",
    "mbk.statusGodkand": "Approved",
    "mbk.statusUtlamnad": "Out",
    "mbk.statusAterlamnad": "Returned",
    "mbk.statusAvbruten": "Cancelled",
    "mbk.savings": "CO2e saved",
    "mbk.savingsCompare": "Compared to buying new",
    "mbk.empty": "No bookings",

    // QR
    "qr.title": "QR code",
    "qr.scanHint": "Scan to open detail page (login required)",
    "qr.copyLink": "Copy link",
    "qr.linkCopied": "Link copied",
    "qr.modeDetail": "Detail page",
    "qr.modeQuickBook": "Quick book",
    "qr.scanHintQuickBook": "Scan to quick-book the machine",
    "qr.scanHintQuickBookMaterial": "Scan to quick-take material from inventory",
    "qr.show": "Show QR code",
    "qr.hide": "Hide QR code",

    // Material quick-take (QR scan)
    "lqb.heading": "Quick-take from inventory",
    "lqb.available": "Available: {qty} {unit}",
    "lqb.bokare": "Who's taking it?",
    "lqb.bokarePh": "Your name",
    "lqb.qty": "How much are you taking?",
    "lqb.qtyHint": "Enter a valid quantity",
    "lqb.qtyOver": "Max available is {max} {unit}",
    "lqb.project": "Project (optional)",
    "lqb.projectNone": "No project",
    "lqb.method": "How are you taking it?",
    "lqb.pickup": "Pick up now",
    "lqb.delivery": "Delivery",
    "lqb.submit": "Confirm take",
    "lqb.submitting": "Submitting…",
    "lqb.failed": "Could not create booking",
    "lqb.successTitle": "Done!",
    "lqb.successBody": "You took {qty} {unit} of \"{title}\". The booking has been recorded.",
    "lqb.bookAnother": "New quick-take",
    "lqb.viewDetail": "Open material page",
    "qr.export": "Export",
    "qr.exporting": "Exporting…",
    "qr.exportPng": "PNG image",
    "qr.exportPdf": "PDF for print",
    "qr.exportZpl": "ZPL (Zebra label)",
    "qr.exportOk": "{kind} downloaded",
    "qr.exportFailed": "Export failed — please retry",
    "qr.printNow": "Print now",
    "qr.printing": "Printing…",
    "qr.printSent": "Sent to {printer}",
    "qr.printFailed": "Print failed",
    "qr.copies": "Number of copies",

    // Printers (org settings)
    "printer.title": "Network printers",
    "printer.subtitle": "Configure Zebra label printers on your network. With an active printer you can print QR labels directly from any machine or inventory page with one click.",
    "printer.empty": "No printers configured yet",
    "printer.default": "Default",
    "printer.test": "Test",
    "printer.testOk": "Printer responds — connection OK",
    "printer.testFail": "Printer not responding: {err}",
    "printer.makeDefault": "Set as default",
    "printer.add": "Add printer",
    "printer.namePh": "Name (e.g. Depot Stockholm)",
    "printer.hostPh": "IP or hostname (e.g. 192.168.10.50)",
    "printer.portPh": "Port (usually 9100)",
    "printer.notePh": "Note (optional)",
    "printer.markDefault": "Use as organisation default printer",
    "printer.help": "Uses Zebra raw TCP protocol on port 9100. Works with any Zebra GK/ZD/ZT printer model.",
    "printer.created": "Printer added",
    "printer.createFailed": "Could not add printer",
    "printer.updateFailed": "Could not update printer",
    "printer.deleteFailed": "Could not delete printer",
    "printer.loadFailed": "Could not load printers",
    "printer.confirmDelete": "Remove printer \"{name}\"?",

    // Quick book
    "qb.title": "Quick book",
    "qb.subtitle": "Three questions — then you're booked",
    "qb.q1": "Who will use the machine?",
    "qb.q1Hint": "Type your or a colleague's name",
    "qb.q2": "Where will it be used?",
    "qb.q2Project": "Project",
    "qb.q2Location": "Location / site",
    "qb.q3": "How long?",
    "qb.duration2h": "2 h",
    "qb.duration4h": "4 h",
    "qb.duration8h": "8 h",
    "qb.duration1d": "1 day",
    "qb.duration3d": "3 days",
    "qb.duration1w": "1 week",
    "qb.durationCustom": "Custom hours",
    "qb.confirm": "Confirm booking",
    "qb.success": "Machine booked!",
    "qb.successDetail": "Your booking is recorded. Find it on the machine detail page.",
    "qb.bookAnother": "Book another",
    "qb.viewDetail": "View machine detail",
    "qb.summary": "Summary",
    "qb.from": "From",
    "qb.to": "To",

    // CO2e Dashboard
    "nav.co2e": "CO2e",
    "co2eDash.label": "[ Climate overview ]",
    "co2eDash.title": "CO2e savings",
    "co2eDash.subtitle": "Summary of savings from reused materials and shared machines.",
    "co2eDash.totalSaved": "Total saved",
    "co2eDash.materialSaved": "Material",
    "co2eDash.machineSaved": "Machines (rental)",
    "co2eDash.projects": "Projects",
    "co2eDash.overTime": "CO2e saved over time",
    "co2eDash.perCategory": "CO2e per category",
    "co2eDash.perProject": "CO2e per project",
    "co2eDash.hyraVsKop": "Rent vs. buy new",
    "co2eDash.kop": "If bought new",
    "co2eDash.hyra": "Actual rental",
    "co2eDash.besparing": "Total saved",
    "co2eDash.top10Machines": "Top 10 machines",
    "co2eDash.top10Materials": "Top 10 materials",
    "co2eDash.noProjects": "No projects with savings yet",
    "co2eDash.noMachines": "No machines with bookings yet",
    "co2eDash.noMaterials": "No material listings yet",
    "co2eDash.kalla": "Source: generic climate data · CO2e_saved = CO2e_buy − (transport + 1 kg maintenance)",

    // Landing page
    "ld.hero.label": "[ ReSource Build · Circular Asset Platform ]",
    "ld.hero.title1": "The Complete",
    "ld.hero.title2": "Circular Asset",
    "ld.hero.title3": "Platform for Construction",
    "ld.hero.subBefore": "Manage, share and reuse everything your construction organization owns —",
    "ld.hero.subBold": "materials, machines, tools and site inventory.",
    "ld.hero.subAfter": " One platform. Real CO₂e impact. Visible from day one.",
    "ld.hero.browse": "Browse materials",
    "ld.hero.explore": "Explore the platform",
    "ld.hero.liveLabel": "[ Live now ]",
    "ld.hero.liveText": "Materials · Machines · Inventory · Projects",
    "ld.stat.tons": "Tonnes diverted",
    "ld.stat.sellers": "Active sellers",
    "ld.stat.cities": "Cities live",

    "ld.value.label": "[ 01 · Why this exists ]",
    "ld.value.title1": "More than a marketplace —",
    "ld.value.title2": "a complete asset system",
    "ld.value.title3": "for construction",
    "ld.value.body": "Construction is the world's largest material consumer — and one of its biggest waste producers. Most assets sit idle in storage or get thrown away when projects end. ReSource Build fixes that by combining six workflows in one platform:",
    "ld.value.p1": "Material reuse",
    "ld.value.p2": "Machine & tool booking",
    "ld.value.p3": "Inventory management",
    "ld.value.p4": "Project linking",
    "ld.value.p5": "CO₂e calculation",
    "ld.value.p6": "Fleet & emission reporting",

    "ld.feat.label": "[ 02 · The five building blocks ]",
    "ld.feat.title1": "Every asset in your organization, in",
    "ld.feat.title2": "one place",
    "ld.feat.aTitle": "Material Marketplace",
    "ld.feat.aKicker": "Reuse what others discard",
    "ld.feat.a1": "Reuse listings with photos, quality grade and quantity",
    "ld.feat.a2": "Internal-only or external visibility per organization",
    "ld.feat.a3": "Live stock status (pcs / m² / lpm)",
    "ld.feat.a4": "Automatic CO₂e per material based on generic climate data",
    "ld.feat.a5": "Booking flow for pickup or delivery",
    "ld.feat.aCta": "Browse marketplace",

    "ld.feat.bTitle": "Machines & Tools",
    "ld.feat.bKicker": "Share, don't double-buy",
    "ld.feat.b1": "Calendar-based booking with collision detection",
    "ld.feat.b2": "Operating hours & service-interval tracking",
    "ld.feat.b3": "QR codes for one-scan quick booking",
    "ld.feat.b4": "Approve → pickup → return workflow",
    "ld.feat.b5": "CO₂e savings: rent vs. buying new, calculated per booking",
    "ld.feat.bCta": "View machines",

    "ld.feat.cTitle": "Inventory Management",
    "ld.feat.cKicker": "Site huts, scaffolding, signs & more",
    "ld.feat.c1": "Track site huts, containers, scaffolding, safety equipment, signs",
    "ld.feat.c2": "Status: free · out · broken — with full history",
    "ld.feat.c3": "Location at every stage of every project",
    "ld.feat.c4": "QR tags for instant scan-and-find",
    "ld.feat.c5": "Linked to the responsible person and project",
    "ld.feat.cCta": "View inventory",

    "ld.feat.dTitle": "Projects & Organization",
    "ld.feat.dKicker": "Structure, roles, visibility",
    "ld.feat.d1": "Link any asset (material, machine, inventory) to a project",
    "ld.feat.d2": "Organization roles: admin, seller, buyer",
    "ld.feat.d3": "Departments, owner email, subscription tier",
    "ld.feat.d4": "Internal-only / Hybrid / Open marketplace per org",
    "ld.feat.d5": "Aggregate climate impact across all your projects",
    "ld.feat.dCta": "View projects",

    "ld.feat.eTitle": "Vehicles & fleet",
    "ld.feat.eKicker": "Emissions per vehicle. Per project. Per period.",
    "ld.feat.eLead": "Full control of your fleet's CO₂ footprint — automatic, individual, reportable.",
    "ld.feat.e1": "Per-vehicle emission reports — diesel, petrol, HVO, electric, hybrid",
    "ld.feat.e2": "Aggregate CO₂ at the project level for clean client reporting",
    "ld.feat.e3": "Period reports: month, quarter, year — exportable for audit",
    "ld.feat.e4": "Auto-reminders for inspection & service — never miss a deadline",
    "ld.feat.e5": "Trailers, rental reporting & auto-billing summary on return",
    "ld.feat.eCta": "Explore vehicles",
    "ld.feat.eBadge": "New in 2026",

    "ld.collab.label": "[ 04 · Collaboration & network ]",
    "ld.collab.title1": "Log your assets.",
    "ld.collab.title2": "Build your network.",
    "ld.collab.title3": "Share smarter.",
    "ld.collab.lead": "The platform grows stronger the more you share. Invite your partners, suppliers and subcontractors — and turn their inventory into an extension of yours.",
    "ld.collab.s1Title": "Log",
    "ld.collab.s1Body": "Materials, machines and inventory registered once — visible to you immediately and ready to share when you choose.",
    "ld.collab.s2Title": "Connect",
    "ld.collab.s2Body": "Invite partner organisations. When they accept, a shared network opens where you can see each other's assets.",
    "ld.collab.s3Title": "Share",
    "ld.collab.s3Body": "Book or buy directly across organisations — you stay in control of what's visible, to whom and at what price.",
    "ld.collab.b1": "Closed, hybrid or open — pick visibility per resource",
    "ld.collab.b2": "Email invites, automatic for same domain",
    "ld.collab.b3": "Book in partner orgs without leaving the platform",
    "ld.collab.b4": "Every action logged — full audit trail",
    "ld.collab.cta": "Build your network",

    "ld.dash.label": "[ 05 · CO₂e Dashboard ]",
    "ld.dash.title1": "Climate impact",
    "ld.dash.title2": "made visible",
    "ld.dash.body": "ReSource Build automatically calculates CO₂e savings from every material reused, every machine shared and every transport avoided. Generic climate factors are baked in — no spreadsheets, no consultants.",
    "ld.dash.p1": "Total CO₂e savings, organization-wide",
    "ld.dash.p2": "Per project, per month, per category",
    "ld.dash.p3": "Top 10 machines and materials saving most",
    "ld.dash.p4": "Rent vs. buy comparison — bar by bar",
    "ld.dash.cta": "See the dashboard",
    "ld.dash.mockTotal": "kg CO₂e total",
    "ld.dash.mockBookings": "bookings",
    "ld.dash.mockProjects": "projects",
    "ld.dash.months": "J,F,M,A,M,J,J,A,S,O,N,D",
    "ld.dash.rentVsBuy": "Rent vs buy",
    "ld.dash.buy": "Buy new",
    "ld.dash.rent": "Rental",
    "ld.dash.topMach": "Top machines",

    "ld.why.label": "[ 06 · Why ReSource Build ]",
    "ld.why.title1": "Four outcomes,",
    "ld.why.title2": "one platform",
    "ld.why.aTitle": "Reduce costs",
    "ld.why.aBody": "Avoid duplicate purchases, sell surplus, share assets across departments and projects. Pay only for what you actually need.",
    "ld.why.bTitle": "Reduce CO₂e",
    "ld.why.bBody": "Automatic emissions tracking from generic climate data — every reuse and rental contributes to a measurable, reportable result.",
    "ld.why.cTitle": "Increase control",
    "ld.why.cBody": "Every machine, every inventory item, every kilo of material — with status, location, history and responsible person.",
    "ld.why.dTitle": "Increase collaboration",
    "ld.why.dBody": "Departments, projects and organizations share through one consistent platform. No more Excel sheets, WhatsApp threads or lost emails.",

    "ld.how.label": "[ 07 · How it works ]",
    "ld.how.title1": "Up and running in",
    "ld.how.title2": "four steps",
    "ld.how.s1Title": "Add your assets",
    "ld.how.s1Body": "Materials, machines, tools and inventory — bulk-add or one by one. Photos, locations, types.",
    "ld.how.s2Title": "Organize your projects",
    "ld.how.s2Body": "Create projects and link assets. Set your subscription: closed, hybrid or open marketplace.",
    "ld.how.s3Title": "Share or sell",
    "ld.how.s3Body": "Internal teammates can book machines. External buyers can pick up materials. QR codes everywhere.",
    "ld.how.s4Title": "Track CO₂e savings",
    "ld.how.s4Body": "The dashboard updates in real time as bookings and reuse happen. Export to your sustainability report.",

    "ld.price.label": "[ 06 · Pricing ]",
    "ld.price.title1": "Pick the model that",
    "ld.price.title2": "fits your operation",
    "ld.price.openTier": "Open Marketplace",
    "ld.price.openPrice": "Free",
    "ld.price.openTag": "Public listings, public buyers",
    "ld.price.o1": "Add unlimited material listings",
    "ld.price.o2": "Public visibility on the marketplace",
    "ld.price.o3": "Basic CO₂e per listing",
    "ld.price.o4": "Email support",
    "ld.price.openCta": "Get started",
    "ld.price.hybridTier": "Hybrid",
    "ld.price.hybridPrice": "Recommended",
    "ld.price.hybridTag": "Internal sharing + external trade",
    "ld.price.h1": "Everything in Open",
    "ld.price.h2": "Machines & inventory tracking",
    "ld.price.h3": "Internal projects & roles",
    "ld.price.h4": "External transfer logging",
    "ld.price.h5": "Full CO₂e dashboard with exports",
    "ld.price.h6": "Priority support",
    "ld.price.hybridCta": "Try Hybrid",
    "ld.price.entTier": "Closed Enterprise",
    "ld.price.entPrice": "Premium",
    "ld.price.entTag": "Internal-only, full audit",
    "ld.price.e1": "Everything in Hybrid",
    "ld.price.e2": "Internal-only marketplace",
    "ld.price.e3": "Advanced roles & permissions",
    "ld.price.e4": "Audit log & SSO",
    "ld.price.e5": "Dedicated success manager",
    "ld.price.e6": "SLAs & onboarding",
    "ld.price.entCta": "Contact sales",

    "ld.cta.label": "[ Ready when you are ]",
    "ld.cta.title1": "Start using ReSource Build",
    "ld.cta.title2": "today",
    "ld.cta.body": "Construction companies, municipalities and regions across the country are already cutting waste, costs and CO₂e — visibly. You can be live in an afternoon.",
    "ld.cta.start": "Get started",
    "ld.cta.demo": "Book a demo",

    "ld.trust.firms": "Construction firms",
    "ld.trust.muni": "Municipalities",
    "ld.trust.regions": "Regions",
    "ld.trust.openData": "Open data, generic CO₂e",

    // Collaboration (inter-org)
    "collab.title": "Collaborations",
    "collab.inviteBtn": "Invite",
    "collab.targetEmail": "Org admin email",
    "collab.send": "Send invite",
    "collab.invited": "Invitation sent",
    "collab.incoming": "Incoming invitations",
    "collab.outgoing": "Outgoing invitations",
    "collab.accept": "Accept",
    "collab.accepted": "Accepted collaborations",
    "collab.decline": "Decline",
    "collab.declined": "Invitation declined",
    "collab.cancelInvite": "Cancel",
    "collab.removed": "Collaboration removed",
    "collab.removeConfirm": "Remove this collaboration?",
    "collab.noneYet": "No collaborations yet",

    // Visibility picker — user-friendly (UX refactor)
    "vis.title": "Who sees this?",
    "vis.lead": "Pick who can see this resource.",
    "vis.internal": "Internal",
    "vis.shared": "Shared",
    "vis.public": "Public",
    "vis.internal.title": "Only my organization",
    "vis.shared.title": "Share with partners",
    "vis.public.title": "Public marketplace",
    "vis.internal.hint": "Only your team can see this",
    "vis.shared.hint": "Visible to organizations you collaborate with",
    "vis.shared.helper": "You can change this later",
    "vis.public.hint": "Visible outside your organization",
    "vis.selected": "Selected",
    "vis.status.label": "Right now",
    "vis.status.internal": "Only your team can see this",
    "vis.status.public": "Visible outside your organization",
    "vis.status.sharedAll": "Visible to all {n} partners",
    "vis.status.sharedSome": "Visible to {n} selected partners",
    "vis.status.sharedNone": "No partners yet — only your team sees this",
    "vis.shared.noCollabs": "You have no collaborations yet. Invite a partner org under \"My org\" first — then you can share resources with them.",
    "vis.advanced.toggle": "Advanced: choose specific partners",
    "vis.advanced.hint": "Leave all unselected to share with ALL collaborations (recommended). Pick specific ones to restrict.",
    "vis.advanced.clear": "Clear selection (share with all)",
    "vis.sell.title": "This will be visible externally",
    "vis.sell.question": "Do you want to sell it or give it away?",
    "vis.sell.sell": "Sell",
    "vis.sell.giveaway": "Give away (free)",
    "vis.sell.giveawayHint": "Price will be set to 0 — anyone can claim it for free.",
    "vis.sell.pickOne": "Pick sell or give away first",
    "vis.sell.cancel": "Cancel",
    "vis.sell.priceLabel": "Enter a price",
    "vis.sell.confirm": "Confirm price",
    "vis.sell.invalidPrice": "Enter a price greater than 0",
    "vis.sharedWithLabel": "Share with specific partners",
    "vis.sharedAllHint": "Leave empty to share with all partners.",
    "vis.save": "Save",
    "vis.saved": "Visibility saved",
    "vis.externalTag": "External resource",
    "vis.sharedTag": "Shared",
    "vis.publicTag": "Public",
    // Next-actions panel (after save)
    "next.title": "What do you want to do next?",
    "next.lead": "Saved. Pick a next step.",
    "next.addNew": "Add new",
    "next.viewAll": "View all",
    "next.assignProject": "Assign to project",
    "next.share": "Share or publish",
    // Resource transfer (booking → buyer's resources)
    "transfer.title": "Material ready to receive",
    "transfer.question": "Do you want to add this material to your organisation's resources?",
    "transfer.yes": "Yes, add it",
    "transfer.no": "No",
    "transfer.success": "Material has been added to your organisation",
    "transfer.addedTag": "Added to resources",
    // Unified status labels across materials / machines / inventory
    "status.machine.available": "Available",
    "status.machine.booked": "Booked",
    "status.machine.inUse": "In use",
    "status.machine.service": "Service",
    "status.machine.broken": "Out of service",
    "status.inv.available": "Available",
    "status.inv.checkedOut": "Checked out",
    "status.mat.available": "Available",
    "status.mat.reserved": "Reserved",
    "status.mat.completed": "Completed",

    // Login / Register (email + password fallback)
    "login.title": "Sign in",
    "login.registerTitle": "Create account",
    "login.subtitle": "Use email & password or continue with Google.",
    "login.tabLogin": "Sign in",
    "login.tabRegister": "Register",
    "login.email": "Email",
    "login.password": "Password",
    "login.passwordHint": "At least 8 characters",
    "login.name": "Name",
    "login.submit": "Sign in",
    "login.registerSubmit": "Create account",
    "login.or": "or",
    "login.google": "Continue with Google",
    "login.welcomeBack": "Welcome back",
    "login.created": "Account created",
    "login.chooseTitle": "Choose sign-in method",
    "login.chooseSubtitle": "Sign in with Google for quick access, or use email & password.",
    "login.googleTitle": "Sign in with Google",
    "login.googleHint": "One-click sign-in via your Google account.",
    "login.emailTitle": "Email & password",
    "login.emailHint": "Register here. Works even if Google blocks you.",
    "login.continue": "Continue",
    "login.backToMethods": "Back to options",
    "login.turnstile.label": "Security verification",
    "login.turnstile.required": "Please complete the security verification above",
    "login.forgotPassword": "Forgot password?",

    // Forgot/Reset Password
    "forgot.requestTitle": "Forgot password",
    "forgot.requestSubtitle": "Enter your email and we'll send you a link to reset your password.",
    "forgot.requestSubmit": "Send reset link",
    "forgot.sentTitle": "Email sent",
    "forgot.sentBody": "If the email is in our system, we've sent a reset link. The link is valid for 30 minutes. Check your spam folder too.",
    "forgot.resetTitle": "Choose a new password",
    "forgot.resetSubtitle": "Enter your new password below.",
    "forgot.newPassword": "New password",
    "forgot.confirmPassword": "Confirm password",
    "forgot.resetSubmit": "Save password",
    "forgot.resetOk": "Password updated. Sign in with your new password.",
    "forgot.mismatch": "Passwords don't match",
    "nav.menu": "Menu",
    // Vehicles module
    "nav.vehicles": "Vehicles",
    "veh.title": "Vehicles",
    "veh.label": "[ Fleet ]",
    "veh.tab.overview": "Overview",
    "veh.tab.all": "All vehicles",
    "veh.tab.inspections": "Inspections",
    "veh.tab.services": "Services",
    "veh.tab.co2": "CO₂ reports",
    "veh.tab.documents": "Documents",
    "veh.new": "New vehicle",
    "veh.regnr": "Registration",
    "veh.brand": "Brand",
    "veh.model": "Model",
    "veh.year": "Year",
    "veh.fueltype": "Fuel type",
    "veh.consumption": "Consumption (L or kWh / 100 km)",
    "veh.odometer": "Odometer (km)",
    "veh.responsible": "Responsible",
    "veh.responsiblePh": "Pick a responsible user",
    "veh.inspectionOrg": "Inspection authority",
    "veh.workshop": "Workshop",
    "veh.nextInspection": "Next inspection",
    "veh.nextService": "Next service",
    "veh.status": "Status",
    "veh.notes": "Notes",
    "veh.documents": "Documents",
    "veh.empty": "No vehicles yet",
    "veh.created": "Vehicle created",
    "veh.updated": "Vehicle updated",
    "veh.deleted": "Vehicle deleted",
    "veh.confirmDelete": "Delete this vehicle? All inspections, services and CO₂ data will be removed.",
    "veh.duplicate": "A vehicle with this registration already exists",
    "veh.status.aktiv": "Active",
    "veh.status.service": "In service",
    "veh.status.ur_drift": "Out of service",
    "veh.status.salt": "Sold",
    "veh.fuel.diesel": "Diesel",
    "veh.fuel.bensin": "Petrol",
    "veh.fuel.el": "Electric",
    "veh.fuel.hvo": "HVO",
    "veh.fuel.hybrid": "Hybrid",
    "veh.fuel.gas": "Gas",
    "veh.history": "History",
    "veh.bookInspection": "Book inspection",
    "veh.bookService": "Book service",
    "veh.markDone": "Mark done",
    "veh.uploadProtocol": "Upload protocol",
    "veh.uploaded": "Document uploaded",
    "veh.detach": "Remove",
    "veh.outOfCompliance": "Overdue",
    "veh.info": "Information",
    "veh.lastInspection": "Last inspection",
    "veh.lastService": "Last service",
    "veh.noLast": "None",
    "veh.km": "km",
    "veh.kr": "kr",
    "vins.title": "Inspections",
    "vins.upcoming": "Upcoming inspections",
    "vins.all": "All inspections",
    "vins.date": "Date",
    "vins.result": "Result",
    "vins.pass": "Pass",
    "vins.fail": "Fail",
    "vins.pending": "Booked",
    "vins.markPass": "Mark as pass",
    "vins.markFail": "Mark as fail",
    "vins.bookNew": "Book new inspection",
    "vins.reinspection": "Reinspection",
    "vins.nextDate": "Next inspection date",
    "vins.createdReinspection": "Reinspection created within 30 days",
    "vins.empty": "No inspections",
    "vsvc.title": "Services",
    "vsvc.upcoming": "Upcoming services",
    "vsvc.all": "All services",
    "vsvc.type": "Service type",
    "vsvc.type.regular": "Regular service",
    "vsvc.type.tire": "Tire change",
    "vsvc.type.repair": "Repair",
    "vsvc.type.inspection_prep": "Pre-inspection",
    "vsvc.cost": "Cost",
    "vsvc.completed": "Completed",
    "vsvc.markCompleted": "Mark completed",
    "vsvc.bookNew": "Book new service",
    "vsvc.empty": "No services planned",
    "vco2.title": "CO₂ reports",
    "vco2.subtitle": "Per vehicle, project and period — calculated from fuel and distance",
    "vco2.period": "Period",
    "vco2.period.month": "Month",
    "vco2.period.quarter": "Quarter",
    "vco2.period.year": "Year",
    "vco2.distance": "Distance (km)",
    "vco2.fuelUsed": "Fuel used",
    "vco2.co2": "CO₂e (kg)",
    "vco2.project": "Project",
    "vco2.addRecord": "Log trip",
    "vco2.empty": "No CO₂ records yet",
    "vco2.month": "This month",
    "vco2.quarter": "This quarter",
    "vco2.year": "This year",
    "vco2.perProject": "CO₂ per project",
    "vco2.topVehicles": "Top emitters",
    "vco2.trend": "CO₂ over time",
    "vco2.kgCO2": "kg CO₂e",
    "vco2.allVehicles": "All vehicles",
    "vco2.allProjects": "All projects",
    "vco2.aggregated": "CO₂ record saved",
    "vrem.title": "Reminders",
    "vrem.due": "Due",
    "vrem.type.inspection": "Inspection",
    "vrem.type.service": "Service",
    "vrem.type.reinspection": "Reinspection",
    "vrem.empty": "No upcoming reminders",
    "vdash.upcomingInspections": "Upcoming inspections",
    "vdash.upcomingServices": "Upcoming services",
    "vdash.outOfCompliance": "Vehicles out of compliance",
    "vdash.activeReminders": "Active reminders",
    "vdash.totalVehicles": "Total vehicles",
    "vdash.viewAll": "View all →",
    "vdash.noData": "No data yet",
    "vdash.filter.period": "Period",
    "vdash.filter.project": "Project",
    "vdash.filter.vehicle": "Vehicle",
    "notif.vehicle_inspection_due": "Inspection of {regnr} is due {due}",
    "notif.vehicle_service_due": "Service of {regnr} is due {due}",
    "notif.vehicle_reinspection_due": "Reinspection of {regnr} is due {due}",

    // Bulk import (CSV/XLSX)
    "bulk.title.vehicles": "Bulk import vehicles (CSV/XLSX)",
    "bulk.title.adminUsers": "Bulk import users (CSV/XLSX)",
    "bulk.title.orgInvites": "Bulk invite users (CSV/XLSX)",
    "bulk.desc.vehicles": "Upload a CSV or Excel file with vehicles. Existing regnrs in your organisation are updated, new ones are created. Empty fields are ignored. Max 1,000 rows per import.",
    "bulk.desc.adminUsers": "Upload a CSV/Excel file with users. Existing emails are skipped. Temporary passwords are generated and emailed (if Resend is configured).",
    "bulk.desc.orgInvites": "Upload a CSV/Excel file with colleagues to invite to your organisation. They'll get an email and can accept when they sign in.",
    "bulk.downloadTemplate": "Download template",
    "bulk.import": "Import CSV",
    "bulk.dropHint": "Drop file here or click to browse",
    "bulk.upload": "Import",
    "bulk.uploading": "Importing…",
    "bulk.uploadAnother": "Import more",
    "bulk.created": "Created",
    "bulk.updated": "Updated",
    "bulk.skipped": "Skipped",
    "bulk.invited": "Invited",
    "bulk.errors": "Errors",
    "bulk.errorsTitle": "Errors per row",
    "bulk.row": "Row",
    "bulk.tempPasswords": "Temporary passwords (shown only now)",
    "bulk.tempPasswordsHelp": "Sent via email. Copy now if Resend isn't configured.",

    // Rental reporting + Trailers
    "rental.toggle": "Activate rental reporting (customer jobs)",
    "rental.toggleHelp": "When activated, booking this resource requires a project and a responsible user. When returned, a booking summary is auto-generated and emailed to the org's accounting recipients.",
    "rental.hourlyRate": "Hourly rate (SEK/h)",
    "rental.responsible": "Responsible user",
    "rental.requiredHint": "Pick a project and responsible user",
    "rental.willGenerate": "→ Rental summary on return",
    "rental.accountingEmails": "Accounting recipients (email)",
    "rental.accountingEmailsHelp": "Recipients of automatic rental summaries. One per line.",
    "rental.saved": "Settings saved",
    "trl.title": "Trailers",
    "trl.label": "[ Trailer fleet ]",
    "trl.new": "New trailer",
    "trl.empty": "No trailers yet",
    "trl.namn": "Display name",
    "trl.kapacitet": "Load capacity (kg)",
    "trl.storlek": "Size",
    "trl.book": "Book",
    "trl.created": "Trailer created",
    "trl.updated": "Trailer updated",
    "trl.deleted": "Trailer deleted",
    "trl.duplicate": "A trailer with this regnr already exists",
    "rrep.title": "Rental reports",
    "rrep.subtitle": "Auto-generated summaries from returned customer rentals — exportable for billing",
    "rrep.totalHours": "Total hours",
    "rrep.totalCost": "Total cost",
    "rrep.count": "Count",
    "rrep.resource": "Resource",
    "rrep.project": "Project",
    "rrep.responsible": "Responsible",
    "rrep.duration": "Duration",
    "rrep.cost": "Cost",
    "rrep.empty": "No rental reports yet",
    "rrep.emailSent": "Email sent",
    "rrep.emailPending": "Pending",
    "rrep.resend": "Resend",
    "rrep.exportCsv": "Export CSV",
    "rrep.filter.all": "All resource types",
    "rrep.filter.machine": "Machines",
    "rrep.filter.trailer": "Trailers",
    "rrep.filter.days30": "30 days",
    "rrep.filter.days90": "90 days",
    "rrep.filter.days365": "1 year",
    "rrep.filter.all_time": "All time",
    "cal.legend.free": "Free",
    "cal.legend.partial": "Partially booked",
    "cal.legend.full": "Fully booked",

    // Locked-module gating for unauthenticated visitors
    "locked.hover": "This module is part of ReSource Hybrid/Organisation. Contact us to activate.",
    "locked.modal.title": "Hybrid/Organisation required",
    "locked.modal.text": "This module is part of ReSource Hybrid/Closed. Contact us to activate.",
    "locked.modal.hint": "Already have an account? Sign in to continue.",
    "locked.modal.button": "Contact us",
    "locked.modal.later": "Close",

    // ========== Landing page v2 (conversion-optimized) ==========
    "lp.hero.pretitle": "FOR CONSTRUCTION FIRMS · MUNICIPALITIES · REGIONS",
    "lp.hero.h1a": "Stop buying new.",
    "lp.hero.h1b": "Start sharing.",
    "lp.hero.sub": "ReSource Build brings materials, machines, vehicles and inventory into one platform. Less waste, lower cost, automatic CO₂ reporting — visible from day one.",
    "lp.hero.audience": "Construction firms · Equipment rental · Subcontractors · Municipalities & regions",
    "lp.hero.note": "Up and running in an afternoon. No Excel. No consultants.",
    "lp.hero.ctaDemo": "Book a demo",
    "lp.hero.ctaTry": "Browse materials",
    "lp.hero.ctaSample": "Explore the platform",
    "lp.hero.trust": "Built for Swedish construction firms, municipalities and regions",
    "lp.hero.uiLabel": "[ UI · Overview ]",
    "lp.hero.uiCaption": "Materials · Machines · Vehicles · Inventory — one view",

    "lp.value.title": "Concrete results — from the first booking.",
    "lp.value.v1": "Cut purchasing cost 15–30 % via reuse and sharing across projects",
    "lp.value.v2": "Raise your reuse rate — measure tonnes of material reused per project and period",
    "lp.value.v3": "Full visibility of materials, machines and vehicles — one page, no Excel",
    "lp.value.v4": "Automatic CO₂e reporting for CSRD, EU taxonomy and public procurement",
    "lp.value.v5": "Rental to billing summary, automatic — project, hours and rate on return",

    "lp.fleet.label": "[ 03 · Vehicles & fleet ]",
    "lp.fleet.title": "Emissions per vehicle. Per project. Per period.",
    "lp.fleet.sub": "Full control of your fleet's CO₂ footprint — automatic, individual, and reportable for sustainability filings or public procurement.",
    "lp.fleet.b1": "Diesel, petrol, HVO, electric, hybrid — Swedish factors",
    "lp.fleet.b2": "Aggregate per project for clean client reports",
    "lp.fleet.b3": "Month, quarter, year — exportable",
    "lp.fleet.b4": "Auto-reminders for inspection & service",
    "lp.fleet.cta": "Explore vehicles",
    "lp.fleet.rentalCta": "Rental reports",
    "lp.fleet.uiLabel": "[ UI · Emission report ]",
    "lp.fleet.uiCaption": "Volvo FH · Scania R450 · Tesla M3 — kg CO₂e per vehicle",

    "lp.co2e.label": "[ 04 · CO₂e Dashboard ]",
    "lp.co2e.title": "Climate impact — visible from the first booking.",
    "lp.co2e.sub": "Generic climate factors baked in. No spreadsheets. No consultants.",
    "lp.co2e.howT": "How the calculation works",
    "lp.co2e.how1": "Fuel + Swedish electricity mix → emission factor per km / kWh",
    "lp.co2e.how2": "Material weight × category factor for avoided production",
    "lp.co2e.how3": "Rental vs buying new → avoided production emissions per booking",
    "lp.co2e.b1": "Total CO₂e — across the whole organisation",
    "lp.co2e.b2": "Per project, month, category",
    "lp.co2e.b3": "Top 10 machines and materials",
    "lp.co2e.b4": "Rent vs buy — bar by bar",
    "lp.co2e.cta": "Open dashboard",
    "lp.co2e.uiLabel": "[ UI · CO₂e savings ]",
    "lp.co2e.uiCaption": "2,140 kg total · 48 bookings · 12 projects — example",

    "lp.feat.label": "[ Features ]",
    "lp.feat.title": "One platform. Six workflows.",
    "lp.feat.uiLabel": "UI preview",
    "lp.feat.materialT": "Material marketplace",
    "lp.feat.material1": "Photo, quality, quantity, CO₂",
    "lp.feat.material2": "Book pickup or delivery",
    "lp.feat.material3": "Internal, hybrid or public",
    "lp.feat.materialCta": "Browse marketplace",
    "lp.feat.machT": "Machines & tools",
    "lp.feat.mach1": "Calendar booking, no clashes",
    "lp.feat.mach2": "QR booking in seconds",
    "lp.feat.mach3": "Operating hours & service tracked",
    "lp.feat.machCta": "View machines",
    "lp.feat.vehT": "Vehicles & emissions",
    "lp.feat.veh1": "CO₂ per vehicle, project, period",
    "lp.feat.veh2": "Reminders for service & inspection",
    "lp.feat.veh3": "Trailers + rental reports — automatic",
    "lp.feat.vehCta": "Explore vehicles",
    "lp.feat.invT": "Inventory & site huts",
    "lp.feat.inv1": "Huts, scaffolding, safety gear",
    "lp.feat.inv2": "Status & history per item",
    "lp.feat.inv3": "QR tag on every item",
    "lp.feat.invCta": "View inventory",
    "lp.feat.collabT": "Collaboration & network",
    "lp.feat.collab1": "Invite partners & subcontractors",
    "lp.feat.collab2": "Book across organisations",
    "lp.feat.collab3": "Visibility per resource",
    "lp.feat.collabCta": "Build your network",
    "lp.feat.co2T": "CO₂ dashboard",
    "lp.feat.co21": "Real-time savings — all flows",
    "lp.feat.co22": "Per project · month · category",
    "lp.feat.co23": "Export for CSRD",
    "lp.feat.co2Cta": "Open dashboard",

    "lp.uspLabel": "[ Why now ]",
    "lp.uspTitle": "Construction is changing — faster than ever.",
    "lp.usp1T": "Material costs are climbing",
    "lp.usp1B": "Materials up 20–40 % since 2022. Reuse and sharing cut your purchasing bill immediately — without compromising on quality.",
    "lp.usp2T": "Waste rules are tightening",
    "lp.usp2B": "EU target: cut construction & demolition waste 70 % by 2030. Traceable reuse becomes a requirement, not a bonus.",
    "lp.usp3T": "CSRD & taxonomy from 2026",
    "lp.usp3B": "Large firms must report scope 3 emissions. Subcontractors and suppliers get pulled in — without data, you're out of the tender.",
    "lp.usp4T": "Climate criteria in procurement",
    "lp.usp4B": "Municipalities and regions demand CO₂e data in bids. ReSource Build delivers it — automatically, from your first booking.",

    "lp.proofLabel": "[ Social proof ]",
    "lp.proofTitle": "Customer stories coming soon",
    "lp.proofSub": "We're building case studies together with our first customers. Become one — and have your logo and result featured here.",
    "lp.proofLogoPlaceholder": "Your logo here",
    "lp.proofCaseT": "Case study coming soon",
    "lp.proofCaseB": "Measurable results from real construction projects — tonnes of material reused, kg CO₂e saved, costs reduced.",
    "lp.proofCaseCta": "Become a pilot partner",

    "lp.priceLabel": "[ Pricing ]",
    "lp.priceTitle": "Pick the tier that fits your operation",
    "lp.priceSub": "From 0 kr/mo. Scales with your organisation. Switch any time.",
    "lp.priceRec": "Recommended",
    "lp.priceFromLabel": "From",
    "lp.priceOpenT": "Open",
    "lp.priceOpenP": "Free",
    "lp.priceOpenPHint": "/mo — forever",
    "lp.priceOpenDesc": "Public marketplace for material reuse",
    "lp.priceOpen1": "Unlimited listings",
    "lp.priceOpen2": "Public visibility",
    "lp.priceOpen3": "Basic CO₂ per listing",
    "lp.priceOpen4": "Email support",
    "lp.priceOpenCta": "Get started free",
    "lp.priceHybridT": "Hybrid",
    "lp.priceHybridP": "1,990 kr",
    "lp.priceHybridPHint": "/mo — from",
    "lp.priceHybridDesc": "For orgs that share internally + trade externally",
    "lp.priceHybrid1": "Everything in Open",
    "lp.priceHybrid2": "Machines, vehicles & inventory",
    "lp.priceHybrid3": "Projects, roles & collaboration network",
    "lp.priceHybrid4": "Full CO₂ dashboard + export",
    "lp.priceHybrid5": "Priority support",
    "lp.priceHybridCta": "Book a demo",
    "lp.priceClosedT": "Closed Enterprise",
    "lp.priceClosedP": "Custom",
    "lp.priceClosedPHint": "quote on request",
    "lp.priceClosedDesc": "Internal-only, full audit, SSO",
    "lp.priceClosed1": "Everything in Hybrid",
    "lp.priceClosed2": "Internal-only marketplace",
    "lp.priceClosed3": "Audit log + SSO",
    "lp.priceClosed4": "Dedicated success manager",
    "lp.priceClosed5": "SLA + onboarding",
    "lp.priceClosedCta": "Contact sales",

    "lp.cmp.title": "What's included where",
    "lp.cmp.colFeat": "Feature",
    "lp.cmp.r1": "Material listings (public)",
    "lp.cmp.r2": "Machine booking & calendar",
    "lp.cmp.r3": "Vehicles & fleet + CO₂",
    "lp.cmp.r4": "Inventory & QR codes",
    "lp.cmp.r5": "Collaboration network",
    "lp.cmp.r6": "Rental report + billing email",
    "lp.cmp.r7": "Audit log & SSO",
    "lp.cmp.r8": "Dedicated success manager + SLA",

    "lp.endLabel": "[ Stop waiting ]",
    "lp.endTitle": "Add your first machine today.",
    "lp.endSub": "30 minutes to first booking. Saving from the first rental. Measuring from the first kilometre.",
    "lp.endTrust": "No credit card · No commitment · Swedish support",
  },
};
